export const tips = {
    listingAgreement: {
        title: 'Listing Agreement Help',
        ruleHelp: ['Listing Agreement is required.'],
        generalHelpDesc:
            'The nature of the agreement between the seller and the listing agent. Examples are Exclusive Agency, Exclusive Right to Lease, etc. <a href="https://ddwiki.reso.org/display/DDW17/ListingAgreement+Field" target="_blank" rel="noopener noreferrer">RESO ListingAgreement</a>.'
    },
    listPriceHelp: {
        title: 'List Price Help',
        ruleHelp: ['List Price is required.'],
        generalHelpDesc: `The current price of the property as determined by the seller and the seller's broker. For auctions this is the minimum or reserve price. <a href="https://ddwiki.reso.org/display/DDW17/ListPrice+Field" target="_blank" rel="noopener noreferrer">RESO ListPrice</a>.`
    },
    expirationDateHelp: {
        title: 'Expiration Date Help',
        ruleHelp: ['Expiration Date is required.'],
        generalHelpDesc: `The date when the listing agreement will expire. This is the date entered by the agent reflecting when the change occurred, or will occur, contractually, not a timestamp of when the change was made in the MLS. The expiration date of listings, prior to their expiration, cancellation, sale or lease, is confidential information and should be restricted to the agent and their managers, partners or broker. <a href="https://ddwiki.reso.org/display/DDW17/ExpirationDate+Field" target="_blank" rel="noopener noreferrer">RESO ExpirationDate</a>.`
    },
    housingVouchersYNHelp: {
        title: 'Housing Vouchers YN Help',
        ruleHelp: ['Housing Vouchers YN is required.'],
        generalHelpDesc: `Housing Vouchers YN`
    },
    listingAgreementDocumentHelp: {
        title: 'Listing Agreement Document Help',
        ruleHelp: ['Listing Agreement Document is required.'],
        generalHelpDesc: `The origin of Listing Agreement used between the Listing Agent and the Owner of the property.`
    },
    streetNumber: {
        title: 'Street Number Help',
        ruleHelp: ['Street Number is required.'],
        generalHelpDesc: `The street number portion of a listed property's street address. In some areas the street number may contain non-numeric characters. This field can also contain extensions and modifiers to the street number, such as "1/2" or "-B". This street number field should not include Prefixes, Direction or Suffixes. <a href="https://ddwiki.reso.org/display/DDW17/StreetNumber+Field" target="_blank" rel="noopener noreferrer">RESO StreetNumber</a>.`
    },
    streetName: {
        title: 'Street Name Help',
        ruleHelp: ['Street Name is required.'],
        generalHelpDesc: `The street name portion of a listed property's street address. <a href="https://ddwiki.reso.org/display/DDW17/StreetName+Field" target="_blank" rel="noopener noreferrer">RESO StreetName</a>.`
    },
    unitNumber: {
        title: 'Unit Number Help',
        ruleHelp: ['Unit Number is required.'],
        generalHelpDesc: `Text field containing the number or portion of a larger building or complex. Unit Number should appear following the street suffix or, if it exists, the street suffix direction, in the street address. Examples are: "APT G", "55", etc. <a href="https://ddwiki.reso.org/display/DDW17/UnitNumber+Field" target="_blank" rel="noopener noreferrer">RESO Unit Number</a>.`
    },
    city: {
        title: 'City Help',
        ruleHelp: ['City is required.'],
        generalHelpDesc: `City in the listing address. <a href="https://ddwiki.reso.org/display/DDW17/City+Field" target="_blank" rel="noopener noreferrer">RESO City</a>.`
    },
    state: {
        title: 'State Help',
        ruleHelp: ['State Or Province is required.'],
        generalHelpDesc: `The state in the listing address.`
    },
    country: {
        title: 'Country Help',
        ruleHelp: ['Country is required.'],
        generalHelpDesc: `The Country the property falls in.`
    },
    county: {
        title: 'County Help',
        ruleHelp: ['County Or Parish is required.'],
        generalHelpDesc: `The County the property falls in.`
    },
    zipCode: {
        title: 'Postal Code Help',
        ruleHelp: ['Postal Code is required.'],
        generalHelpDesc: `The postal code portion of a street or mailing address. <a href="https://ddwiki.reso.org/display/DDW17/PostalCode+Field" target="_blank" rel="noopener noreferrer">RESO PostalCode</a>.`
    },
    streetDirSuffix: {
        title: 'Street Dir Suffix Help',
        generalHelpDesc: `The direction indicator that follows a listed property's street address. <a href="https://ddwiki.reso.org/display/DDW17/StreetDirSuffix+Field" target="_blank" rel="noopener noreferrer">RESO StreetDirSuffix</a>.`
    },
    streetDirPrefix: {
        title: 'Street Dir Prefix Help',
        generalHelpDesc: `The direction indicator that precedes a listed property's street name. <a href="https://ddwiki.reso.org/display/DDW17/StreetDirPrefix+Field" target="_blank" rel="noopener noreferrer">RESO StreetDirPrefix</a>.`
    },
    outOfStateCounty: {
        title: 'Out of State County Help',
        ruleHelp: ['Out of State County is required.'],
        generalHelpDesc: `Open text field to type the county of the property, if located outside of Texas.`
    },
    outOfStateCity: {
        title: 'Out of State City Help',
        ruleHelp: ['Out of State City is required.'],
        generalHelpDesc: `Open text field to type the city of the property, if located outside of Texas.`
    },
    taxLot: {
        title: 'Tax Lot Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `A type of legal description for land in developed areas where streets or other rights-of-ways delineate large parcels of land referred to as divided into lots on which homes or other types of developments are built. An example would read "Lot 12 of Block 45 of Tract 3002 of the City of San Dunes, Desert County." Such a description would also reference an official plat filed with the clerk or recorder for that area which shows the location of the block and often the dimensions of the lots therein <a href="https://ddwiki.reso.org/display/DDW17/TaxLot+Field" target="_blank" rel="noopener noreferrer">RESO TaxLot</a>.`
    },
    taxBlock: {
        title: 'Tax Block Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `A type of legal description for land in developed areas where streets or other rights-of-ways delineate large parcels of land referred to as divided into lots on which homes or other types of developments are built. An example would read "Lot 12 of Block 45 of Tract 3002 of the City of San Dunes, Desert County." Such a description would also reference an official plat filed with the clerk or recorder for that area which shows the location of the block and often the dimensions of the lots therein.<a href="https://ddwiki.reso.org/display/DDW17/TaxBlock+Field" target="_blank" rel="noopener noreferrer">RESO TaxBlock</a>.`
    },
    taxLegalDescription: {
        title: 'Tax Legal Description Help',
        ruleHelp: ['Tax Legal Description is required.'],
        generalHelpDesc: `A type of legal description for land in developed areas where streets or other rights-of-ways delineate large parcels of land referred to as divided into lots on which homes or other types of developments are built. An example would read "Lot 12 of Block 45 of Tract 3002 of the City of San Dunes, Desert County." Such a description would also reference an official plat filed with the clerk or recorder for that area which shows the location of the block and often the dimensions of the lots therein. The text here is also an index into the property as described by the County Recorder. <a href="https://ddwiki.reso.org/display/DDW17/TaxLegalDescription+Field" target="_blank" rel="noopener noreferrer">RESO TaxLegalDescription</a>.`
    },
    latitude: {
        title: 'Latitude Help',
        ruleHelp: ['Latitude is required.'],
        generalHelpDesc: `The geographic latitude of some reference point on the property, specified in degrees and decimal parts. Positive numbers must not include the plus symbol.
        <a href="https://ddwiki.reso.org/display/DDW17/Latitude+Field" target="_blank" rel="noopener noreferrer">RESO Latitude</a>.
        <br /><br />
        The geographic longitude of some reference point on the property, specified in degrees and decimal parts. Positive numbers must not include the plus symbol.
        <a href="https://ddwiki.reso.org/display/DDW17/Longitude+Field" target="_blank" rel="noopener noreferrer">RESO Longitude</a>.
        <br /><br />
        Geocode Source
        <br /><br />
        Street View Param
        `
    },
    longitude: {
        title: 'Longitude Help',
        ruleHelp: ['Longitude is required.'],
        generalHelpDesc: `The geographic latitude of some reference point on the property, specified in degrees and decimal parts. Positive numbers must not include the plus symbol.
        <a href="https://ddwiki.reso.org/display/DDW17/Latitude+Field" target="_blank" rel="noopener noreferrer">RESO Latitude</a>.
        <br /><br />
        The geographic longitude of some reference point on the property, specified in degrees and decimal parts. Positive numbers must not include the plus symbol.
        <a href="https://ddwiki.reso.org/display/DDW17/Longitude+Field" target="_blank" rel="noopener noreferrer">RESO Longitude</a>.
        <br /><br />
        Geocode Source
        <br /><br />
        Street View Param
        `
    },
    pid: {
        title: 'Parcel Number Help',
        ruleHelp: ['Parcel Number is required.'],
        generalHelpDesc: `A number used to uniquely identify a parcel or lot. This number is typically issued by the county or county assessor.<a href="https://ddwiki.reso.org/display/DDW17/ParcelNumber+Field" target="_blank" rel="noopener noreferrer">RESO ParcelNumber</a>. <br/> If there is no Parcel Number (PID) use the address of the property. (No dashes)`,
        generalHelp: [
            'Bastrop Short # (includes the R)',
            'Bell Short #',
            'Blanco Short # (includes the R)',
            'Burnet Long #',
            'Caldwell Short #',
            'Comal Long #',
            'Fayette Long #',
            'Gillespie Short #',
            'Gonzales Long #',
            'Guadalupe Short #',
            'Hays Long #',
            'Lampasas Long #',
            'Lee Short #',
            'Llano Long #',
            'Milam Long #',
            'San Saba Long #',
            'Travis Long #',
            'Williamson Long #'
        ]
    },
    mlsArea: {
        title: 'MLS Area Help',
        ruleHelp: ['MLS Area is required.'],
        generalHelpDesc: `The major marketing area name, as defined by ACTRIS MLS.`
    },
    schoolDistrict: {
        title: 'School District Help',
        ruleHelp: [' School District is required.'],
        generalHelpDesc: `The name of the school district the property is zoned to attend and pay taxes to.`
    },
    elementarySchool: {
        title: 'Elementary School Help',
        ruleHelp: ['Elementary School is required.'],
        generalHelpDesc: `The name of the primary school having a catchment area that includes the associated property <a href="https://ddwiki.reso.org/display/DDW17/ElementarySchool+Field" target="_blank" rel="noopener noreferrer">RESO ElementarySchool</a>.`
    },
    middleoRJunior: {
        title: 'Middle or Junior School Help',
        ruleHelp: ['Middle or Junior School is required.'],
        generalHelpDesc: `The name of the junior or middle school having a catchment area that includes the associated property <a href="https://ddwiki.reso.org/display/DDW17/MiddleOrJuniorSchool+Field" target="_blank" rel="noopener noreferrer">RESO MiddleOrJuniorSchool</a>.`
    },
    highSchool: {
        title: 'High School Help',
        ruleHelp: ['High School is required.'],
        generalHelpDesc: `The name of the high school having a catchment area that includes the associated property <a href="https://ddwiki.reso.org/display/DDW17/HighSchool+Field" target="_blank" rel="noopener noreferrer">RESO HighSchool</a>.`
    },
    etj: {
        title: 'ETJ Help',
        ruleHelp: ['ETJ Extra Territorial Jurisdiction is required.'],
        generalHelpDesc: `<strong>Extra Territorial Jurisdiction</strong> - An area outside of the legal jurisdiction of a city or other governmental unit over which that government has limited control. The extent of the territory and the specific controls granted are determined by state law. <br/> <a href="https://maps.austintexas.gov/GIS/JurisdictionsWebMap" target="_blank" rel="noopener noreferrer">Click here to search the Jurisdictions Web Map</a>.`
    },
    femaFlood: {
        title: 'FEMA Flood Plain Help',
        ruleHelp: ['FEMA Flood Plain is required.'],
        generalHelpDesc: `All land adjacent to a watercourse over which water flows in times of flood or would flow but for the presence of flood defenses where they exist. The limits of the floor plain are defined by the peak level of a 1 in 100 year return period flood or the highest known water level, whichever is greater.`
    },
    roomType: {
        title: 'Room Type  Help',
        ruleHelp: ['Room Type is required.'],
        generalHelpDesc: `This field is a list of the types used in the rooms repeating elements. The Type is a list of possible room types. i.e. Bedroom, Bathroom, Living Room, Workshop, etc. **Note that Garage should not be added as a room type and are represented by the Parking Features field. <video src="https://www.youtube.com/watch?v=WvU5Nc8_SJ8"/>`
    },
    roomLevel: {
        title: 'Room Level  Help',
        ruleHelp: ['Room Level is required.'],
        generalHelpDesc: `The Level of the home this row's Room Type is located on.`
    },
    roomFeatures: {
        title: 'Room Features  Help',
        ruleHelp: ['Room Features is required.'],
        generalHelpDesc: `The list of features that can be added to describe the Room selected under this row's Room Type. Ex. Primary Bedroom is selected as Room Type; under Room Features, select Crown Molding, Ceiling Fan(s), and Smart Thermostat to more specifically describe the room.`
    },
    roomDescription: {
        title: 'Room type Description  Help',
        generalHelpDesc: `An open-text field used to describe details for this row's Room Type.`
    },
    disclosures: {
        title: 'Disclosures Help',
        ruleHelp: ['Disclosures is required.'],
        generalHelpDesc: `Legal or pertinent information that should be disclosed to potential buyer's agents. <a href="https://ddwiki.reso.org/display/DDW17/Disclosures+Field" target="_blank" rel="noopener noreferrer"> RESo Disclosures</a>.`
    },
    documentsAvailable: {
        title: 'Documents Available Help',
        ruleHelp: ['Documents Available is required.'],
        generalHelpDesc: `A list of the Documents available for the property. Knowing what documents are available for the property is valuable information. <a href="https://ddwiki.reso.org/display/DDW17/DocumentsAvailable+Field" target="_blank" rel="noopener noreferrer">RESo DocumentsAvailable</a>.`
    },
    Heating: {
        title: 'Heating Help',
        ruleHelp: ['Heating is required.'],
        generalHelpDesc: `A list of the Documents available for the property. Knowing what documents are available for the property is valuable information. <a href="https://ddwiki.reso.org/display/DDW17/Heating+Field" target="_blank" rel="noopener noreferrer">RESo Heating</a>.`
    },
    Utilities: {
        title: 'Utilities Help',
        ruleHelp: ['Utilities is required.'],
        generalHelpDesc: `A list of the utilities for the property being sold/leased.`
    },
    OwnerPays: {
        title: 'Owner Pays Help',
        ruleHelp: ['Owner Pays is required.'],
        generalHelpDesc: `A list of expenses for the property paid for by the owner as opposed to the tenant (e.g. Water, Trash, Electric). <a href="https://ddwiki.reso.org/display/DDW17/OwnerPays+Field" target="_blank" rel="noopener noreferrer">RESo OwnerPays</a>.`
    },
    Cooling: {
        title: 'Cooling Help',
        ruleHelp: ['Cooling is required.'],
        generalHelpDesc: `A list describing the cooling or air conditioning features of the property. <a href="https://ddwiki.reso.org/display/DDW17/Cooling+Field" target="_blank" rel="noopener noreferrer">RESo Cooling</a>.`,
        generalHelp: [
            'Attic Fan: The property has an attic fan.',
            'Central Air: The property has central air conditioning.',
            'Dual: The cooling system has two units.',
            "Ductless: The cooling system does not ducted nor a wall/window type unit. A mini-split is a common type of ductless system where an outdoor condenser is connected to an indoor fan unit that feeds the room in which it's located, rather than being ducted throughout the structure",
            'Electric: The cooling system is powered by electricity.',
            'ENERGY STAR Qualified Equipment: The cooling system is ENERGY STAR Qualified.',
            'Exhuast Fan: The structure has an exhaust fan.',
            'Gas:The cooling system is powered by gas.',
            'Heat Pump: A system that exchanges heat between a warm and cool space. The heat exchange is done between the dwelling and another air space, like outdoors; or a water source; or below ground (geothermal)',
            'Humidity Control: The cooling system includes humidity control.',
            'Multi Units: The cooing system includes more than one unit.',
            'Roof Turbine(s): The cooling utilizes a roof turbine.',
            'Separate Meters: The cooling system has separate meters for its multiple units/zones.',
            'Varies by Unit: The cooling equipment varies by unit.',
            'Wall/Window Unit(s): The cooling system is mounted in an opening in the wall or in a window.',
            'Whole House Fan: The property has a whole house fan.',
            'Zoned: The cooling system has more than one zone.'
        ]
    },
    Sewer: {
        title: 'Sewer Help',
        ruleHelp: ['Sewer is required.'],
        generalHelpDesc: `A list describing the sewer or septic features of the property. <a href="https://ddwiki.reso.org/display/DDW17/Sewer+Field" target="_blank" rel="noopener noreferrer">RESo Sewer</a>.`
    },
    WaterSource: {
        title: 'Water Source Help',
        ruleHelp: ['Water Source is required.'],
        generalHelpDesc: `A list of the source(s) of water for the property.`,
        generalHelp: [
            'Cistern: an underground reservoir for storing rainwater.',
            "Private: the property's source of water is private",
            "Public: the property's source of water is public",
            'MUD: municipal utility district, one of several types of special districts that function as independent, limited governments, for the purpose of providing a ',
            'developer an alternate way to finance infrastructure, such as water, sewer, drainage, and road facilities.',
            "Spring: the property's source of water has/includes a spring",
            "Well: the property's source of water has/includes a well",
            "Shared well: the property's source of water has/includes a shared well"
        ]
    },
    TenantPays: {
        title: 'Tenant Pays Help',
        ruleHelp: ['Tenant Pays is required.'],
        generalHelpDesc: `A list of services or items that the tenant is responsible to pay.`
    },
    MeterDescription: {
        title: 'Meter Description Help',
        ruleHelp: ['Meter Description is required.'],
        generalHelpDesc: `Meter Description`
    },
    propertySubTypes: {
        title: 'Property SubTypes Help',
        ruleHelp: ['Property SubTypes is required.'],
        generalHelpDesc: `A list of types of residential and residential lease properties, i.e. Single Family Resi, Condo, etc. Or a list of Sub Types for Mobile, such as Expando, Manufactured, Modular, etc. RESO PropertySubType.`
    },
    alsoListedAs: {
        title: 'Also Listed As (enter ML#) Help',
        ruleHelp: ['No Rule Defined']
        // generalHelpDesc: `A list of types of residential and residential lease properties, i.e. Single Family Resi, Condo, etc. Or a list of Sub Types for Mobile, such as Expando, Manufactured, Modular, etc. RESO PropertySubType.`
    },
    levels: {
        title: 'Levels Help',
        ruleHelp: ['Levels is required.'],
        generalHelpDesc: `The number of levels in the property being sold/leased. For example, One Level, Two Levels, Three or More Levels, Multi/Split,. A discreet horizontal plane of interior living space (excluding basements).`,
        generalHelp: [
            '1 (One): The property being sold has one level. A discreet horizontal plane of interior living space (excluding basements).',
            '1.5 (One and One Half): All bedrooms, bathrooms, and kitchens are on the main level. There are stairs that lead up to a 2nd floor, but level does not have a bedroom, bathroom, or a kitchen and often lacks a door. Ex. Game Room.',
            '2 (Two): The property being sold has two levels. A discreet horizontal plane of interior living space (excluding basements).',
            '3+ (Three or More): The property being sold has three or more levels. A discreet horizontal plane of interior living space (excluding basements).',
            'Multi/Split: A split-level home (also called a tri-level home) is a style of house in which the floor levels are staggered, so that the "main" level of the house (e.g. the level that usually contains the front entry), is partway between the upper and lower floors.'
        ]
    },
    mainLevelBedrooms: {
        title: 'Main Level Beds Help',
        ruleHelp: ['Main Level Beds is required..'],
        generalHelpDesc: `The number of bedrooms located on the main or entry level of the property. 
        
        <a href="https://ddwiki.reso.org/display/DDW17/MainLevelBedrooms+Field" target="_blank" rel="noopener noreferrer">RESO MainLevelBedrooms</a>
       
      `
    },
    Directions: {
        title: 'Directions Help',
        ruleHelp: ['Directions is required.'],
        generalHelpDesc: `Driving directions to the property. <a href="https://ddwiki.reso.org/display/DDW17/Directions+Field" target="_blank" rel="noopener noreferrer">RESo Directions</a>.`
    },
    PublicRemarks: {
        title: 'Public Remarks Help',
        ruleHelp: ['Public Remarks is required.'],
        generalHelpDesc: `<b>Definition and Rules for Private Remarks</b>
         <ul>
            <li>Public Remarks can contain remarks about the physical description of the property, as well as remarks related to the transaction, such as available financing, seller contributions, cash back at closing, upgrade incentives, upgrade allowances, repair amounts, builder options, and similar information.</li>
             <li>Seller Contribution/Buyer Incentive cannot be limited to or conditioned on the retention of or payment to a cooperating broker, buyer broker, or other buyer representative. Any offer of compensation to Participants is prohibited and a violation will be issued if added.</li>
         </ul>
         <b>The following information is prohibited:</b>
         <ul>
            <li>Confidential information, such as showing instructions or security codes</li>
             <li>Contact information such as names, phone numbers, email addresses</li>
             <li>Web site addresses</li>
             <li>Service provider information</li>
             <li>the words FSBO or For Sale by Owner</li>
             <li>Any offer of compensation to Participants</li>
         </ul>
        `
    },
    PrivateRemarks: {
        title: 'Private Remarks Help',
        ruleHelp: ['Private Remarks is required.'],
        generalHelpDesc: `<b>Definition and Rules for Private Remarks</b>
         <ul>
            <li>Private Remarks can contain remarks related to the transaction, such as available financing, seller contributions, cash back at closing, upgrade incentives, upgrade allowances, repair amounts, builder options, and similar information.</li>
             <li>Seller Contribution/Buyer Incentive cannot be limited to or conditioned on the retention of or payment to a cooperating broker, buyer broker, or other buyer representative. Any offer of compensation to Participants is prohibited and a violation will be issued if added.</li>
         </ul>
        `
    },
    SyndicationRemarks: {
        title: 'Syndication Remarks Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `<b>Definition and Rules for Syndication Remarks</b>
         <ul>
            <li>Syndication Remarks are advertising remarks that will only be available to Publisher websites.</li>
             <li>Seller Contribution/Buyer Incentive cannot be limited to or conditioned on the retention of or payment to a cooperating broker, buyer broker, or other buyer representative. Any offer of compensation to Participants is prohibited and a violation will be issued if added.</li>
         </ul>
        `
    },
    brandedVirtualTourURL: {
        title: 'Virtual Tour URL Branded Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `Input a URL for a branded virtual tour of the property. Branded Virtual Tours may include contact information and other marketing material. Branded Virtual Tours have primary exposure outside of the MLS on 3rd Party Publisher sites.`
    },
    unbrandedVirtualTourURL: {
        title: 'Virtual Tour URL Unbranded Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `Input a URL for an unbranded virtual tour of the property. Unbranded Virtual Tours are NOT allowed to include contact information and other marketing material. Unbranded Virtual Tours have primary exposure inside of the MLS and is the link attached to the "reel" icon on listing displays, as well as the "View Virtual Tour" link.`
    },
    brandedVideoTourURL: {
        title: 'Video Tour Link Branded Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `Input a URL for a branded video tour of the property. Branded Video Tours may include contact information and other marketing material. A video tour can include, but is not limited to, a video walk-through of the property or a drone video filming the exterior of the property.`
    },
    unbrandedVideoTourURL: {
        title: 'Video Tour Link Unbranded Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `Input a URL for an unbranded video tour of the property. Unbranded Video Tours are NOT allowed to include contact information and other marketing material. Unbranded Video Tours have primary exposure inside of the MLS and is the link attached to the "drone" icon on listing displays`
    },
    listingDetailedURL: {
        title: 'Listing Detail URL Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `Enter URL for specific property. Not for community website or agent/office marketing.`
    },
    propertyPanorama: {
        title: 'Create Automatic Virtual Tour YN Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `As an ACTRIS subscriber, you have the option to create a Free Property Panorama InstaView Virtual Tours. Note that the Free tour will create a Virtual Tour slideshow of the first five photos from your listing. To expand to all photos, you can activate within Property Panorama for a cost: 
        <a href="https://www.propertypanorama.com/?next=/dashboard" target="_blank" rel="noopener noreferrer">https://www.propertypanorama.com/manage/tours</a>.
        <br/><br/>
        More info here:
        <a href="https://www.abor.com/api/document/preview/6909" target="_blank" rel="noopener noreferrer">https://www.abor.com/api/document/preview/6909</a>.
                
                <br/><br/>
                Have questions? Contact Property Panorama directly
                <br/><br/>
                Monday – Friday 9:00 am to 5:00 pm EST<br/>
                Email: WizKidz@PropertyPanorama.com<br/>
                Live Chat: www.PropertyPanorama.com<br/>
                Phone: 440-290-2200<br/>
        `
    },
    internetListingDisplay: {
        title: 'Internet Entire Listing Display YN Help',
        ruleHelp: ['Internet Entire Listing Display YN is required.'],
        generalHelpDesc: `A yes/no field that states the seller has allowed the listing to be displayed on Internet sites. If Internet Display is NO, then this listing will also not be included in the IDX data feed. <a href="https://ddwiki.reso.org/display/DDW17/InternetEntireListingDisplayYN+Field" target="_blank" rel="noopener noreferrer">RESO InternetEntireListingDisplayYN</a>.`
    },
    internetAutomatedValuation: {
        title: 'Internet Automated Valuation Display YN Help',
        ruleHelp: ['Internet Automated Valuation Display YN is required.'],
        generalHelpDesc: `A yes/no field that states the seller allows the listing can be displayed with an AVM on Internet sites. An AVM uses statistical calculations to estimate the value of a property based upon data from public records, MLS, and other sources. If NO is selected a VOW may not display an automated valuation next to he property listing. <a href="https://ddwiki.reso.org/display/DDW17/InternetAutomatedValuationDisplayYN+Field" target="_blank" rel="noopener noreferrer">RESO InternetAutomatedValuationDisplayYN</a>.`
    },
    internetConsumerComment: {
        title: 'Internet Consumer Comment YN Help',
        ruleHelp: ['Internet Consumer Comment YN is required.'],
        generalHelpDesc: `A yes/no field that states the seller allows a comment or blog system to be attached to the listing on Internet sites. Some Virtual Office Websites (VOWs) may provide functionality that permits the customer using the VOW to enter comments about the listed properties. If NO is selected a VOW may not display comments or reviews with the listing.<a href="https://ddwiki.reso.org/display/DDW17/InternetConsumerCommentYN+Field" target="_blank" rel="noopener noreferrer">RESO InternetConsumerCommentYN</a>.`
    },
    internetAddressDisplay: {
        title: 'Internet Address Display YN Help',
        ruleHelp: ['Internet Address Display YN is required.'],
        generalHelpDesc: `A yes/no field that states the seller has allowed the listing address to be displayed on Internet sites.<a href="https://ddwiki.reso.org/display/DDW17/InternetAddressDisplayYN+Field" target="_blank" rel="noopener noreferrer">RESO InternetAddressDisplayYN</a>.`
    },
    listingWillAppearOn: {
        title: 'Listing Will Appear On Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `When permitted by the broker, the options made by the agent on behalf of the seller, where they would like their listing syndicated. Current syndication options include: ABoR.com/Search (AustinHomeSearch.com); HAR.com; ListHub; Realtor.com; and Apartments.com Network (Lease only)`
    },
    Furnished: {
        title: 'Furnished Help',
        generalHelpDesc: `The property being leased is furnished, unfurnished or partially furnished. <a href="https://ddwiki.reso.org/display/DDW17/Furnished+Field" target="_blank" rel="noopener noreferrer">RESo Furnished</a>.`
    },
    Fencing: {
        title: 'Fencing Help',
        ruleHelp: ['Fencing is required.'],
        generalHelpDesc: `A list of types of fencing found at the property being sold <a href="https://ddwiki.reso.org/display/DDW17/Fencing+Field" target="_blank" rel="noopener noreferrer">RESo Fencing</a>.`,
        generalHelp: [
            'Back Yard: The back yard is fenced.',
            'Barbed Wire: The fencing has barbed wire.',
            'Block: The property has a block wall(s).',
            'Brick: The property has a brick wall(s).',
            'Chain Link: The property has chain link fencing.',
            'Cross Fenced: The property is cross fenced.',
            'Electric: The property has electric fencing.',
            'Fenced: The property is fenced.',
            'Front Yard: The front yard is fenced.',
            'Full: The full property is fenced.',
            'Gate: The fencing has a gate(s).',
            'Invisible: The property has invisible fencing.',
            'Livestock: The property has a fence, commonly wire, either barbed or wire net, or a combination to hold farm animals. ',
            'Could be wood, but that is more commonly called a corral.',
            'Masonry: The property has masonry wall(s).',
            'Partial: The property is partially fenced.',
            'Perimeter: The property has a perimeter fence.',
            'Pipe: The property has pipe fencing.',
            'Privacy: The property has privacy fencing.',
            'Security: The property has security fencing.',
            'Slump Stone: The property has slump stone wall(s).',
            'Split Rail: The property has split rail fencing.',
            'Stone: The property has stone wall(s).',
            'Vinyl: The property has vinyl fencing.',
            'Wire: The property has wire fencing.',
            'Wood: The property has wooden fencing.',
            'Wrought Iron: The property has wrought iron fencing.'
        ]
    },
    AppliancesMaintained: {
        title: 'Appliances Maintained Help',
        generalHelpDesc: `Appliances Maintained`
    },
    Fireplaces: {
        title: 'Fireplaces Help',
        ruleHelp: ['Fireplaces is required.'],
        generalHelpDesc: `The total number of fireplaces included in the property. <a href="https://ddwiki.reso.org/display/DDW17/FireplacesTotal+Field" target="_blank" rel="noopener noreferrer">RESo FireplacesTotal</a>.`
    },
    fireplaceFeatures: {
        title: 'Fireplace Features Help',
        ruleHelp: ['Fireplace Features is required.'],
        generalHelpDesc: `
        A list of features or description of the fireplace(s) included in the sale/lease.
        <a href="https://ddwiki.reso.org/display/DDW17/FireplaceFeatures+Field" target="_blank" rel="noopener noreferrer">RESO FireplaceFeatures</a>.
        `,
        generalHelp: [
            'Basement: There is a fireplace in the basement.',
            'Bathroom: The property includes a bathroom fireplace.',
            'Bedroom: The property has a bedroom fireplace.',
            'Blower Fan: The fireplace has a blower fan.',
            'Circulating: The fireplace has a circulation system.',
            'Decorative: The property has a decorative fireplace.',
            'Den: The property has a fireplace in the den.',
            'Dining Room: The property has a fireplace in the dining room.',
            'Double Sided: The property has a double sided fireplace. Double sided fireplaces often have openings in adjacent rooms.',
            'Electric: The fireplace is electric.',
            'EPA Cert Wood Stove: The property has an EPA certified wood stove.',
            'EPA Qualified Fireplace: The property has an EPA certified fireplace.',
            'Factory Built: The fireplace is factory built and later installed into the property.',
            'Family Room: There is a fireplace in the family room.',
            'Fire Pit: The property has a fire pit.',
            'Free Standing: The fireplace is free standing, rather than built-in.',
            'Gas: The fireplace burns gas.',
            'Gas Log: The gas fireplace has a gas log.',
            'Gas Starter: The fireplace has a gas starter but also burns wood or other fuels.',
            'Glass Doors: The fireplace has glass doors.',
            'Great Room: There is a fireplace in the great room.',
            'Heatilator: The fireplace has a built-in ventilation system used to circulate heat.',
            'Insert: A fireplace insert is a device inserted into an existing masonry or prefabricated fireplace.',
            'Kitchen: The property has a fireplace in the kitchen.',
            'Library: The property has a fireplace in the library.',
            'Living Room: The property has a fireplace in the living room.',
            'Masonry: The fireplace is made of masonry.',
            'Metal: The fireplace is made of metal.',
            'Outside: The property has an outdoor fireplace.',
            'Pellet Stove: The property has a stove that burns compressed wood or biomass pellets to generate heat.',
            'Primary Bedroom: The property has a fireplace in the primary bedroom.',
            'Propane: The fireplace burns propane.',
            'Raised Hearth: The fireplace has a raised hearth.',
            'Recreation Room: The property has a fireplace in the recreation room.',
            'Sealed Combustion: The fireplace has a sealed combustion chamber.',
            'See Through: The property has a see-through fireplace, usually positioned between two rooms.',
            'Stone: The property has a fireplace made with stone.',
            'Ventless: The property has a ventless fireplace.',
            'Zero Clearance: The property has a zero clearance fireplace. Zero clearance fireplaces are built to be placed almost directly against combustible materials like wood, walls, or paneling.'
        ]
    },
    otherStructures: {
        title: 'Other Structures Help',
        ruleHelp: ['Other Structures is required.'],
        generalHelpDesc: `
        A list of structures other than the main dwelling. For example, Guest House, Barn, Shed, etc.
        <a href="https://ddwiki.reso.org/display/DDW17/OtherStructures+Field" target="_blank" rel="noopener noreferrer">RESO OtherStructures</a>.
        `,
        generalHelp: [
            'Airplane Hangar: The property includes an airplane hangar.',
            'Arena: The property includes an arena.',
            'Barn(s): The property includes a barn(s).',
            "Bathroom: The property includes a bathroom that isn't attached.",
            'Boat House: The property includes a boat house.',
            'Cabana: The property includes a cabana.',
            'Cave(s): The property includes a cave(s).',
            'Corral(s): The property includes a corral(s).',
            'Covered Arena: The property includes a covered arena.',
            'Garage(s): The property includes a garage(s).',
            'Gazebo: The property includes a gazebo.',
            'Grain Storage: The property includes grain storage.',
            'Greenhouse: The property includes a greenhouse.',
            'Guest House: The property includes a guest house.',
            'Kennel/Dog Run: The property includes a kennel or dog run.',
            'Mobile Home: The property includes a mobile home.',
            'Outbuilding: The property includes an outbuilding.',
            'Outdoor Kitchen: The property includes an outdoor kitchen.',
            'Packing Shed: The property includes a packing shed.',
            'Pergola: The property includes a pergola.',
            'Pool House: The property includes a pool house.',
            'Poultry Coop: The property includes a poultry coop.',
            'Residence: The property includes a residence structure.',
            'RV/Boat Storage: The property includes RV or boat storage.',
            'Second Residence: The property includes a second residence.',
            'Shed: The property includes a shed(s).',
            'Storage: The property includes storage.',
            'Tennis Court(s): The property includes a tennis court(s).',
            'Workshop: The property includes a workshop.'
        ]
    },
    communityFeatures: {
        title: 'Community Features Help',
        ruleHelp: ['Community Features is required.'],
        generalHelpDesc: `
        A list of features related to, or available within, the community.
        <a href="https://ddwiki.reso.org/display/DDW17/CommunityFeatures+Field" target="_blank" rel="noopener noreferrer">RESO CommunityFeatures</a>.
        `,
        generalHelp: [
            'Airport/Runway: The community has an airport or runway.',
            'BBQ Pit/Grill: A heated structure or area for outdoor cooking/grilling.',
            'Bike Storage/Locker: There is a shared storage area/locker for bicycles.',
            'Business Center: A community business center.',
            'Car Share Available: The community has a car share program available.',
            'Clubhouse: The community has a clubhouse.',
            'Cluster Mailbox: The community uses cluster mailbox(es) for mail collection.',
            'Common Grounds: Portions of a building, land, and amenities used by all unit owners.',
            'Concierge: A service on site of the property that assists with tasks for residents.',
            'Conference/Meeting Room: A room used for staff meetings and departmental activities.',
            'Controlled Access: Access to the community/property is limited to certain people.',
            'Courtyard: There is a shared courtyard.',
            'Covered Parking: The community has shared covered parking spaces.',
            'Creative Office Space: The community has a shared creative office space.',
            'Curbs: The community streets have curbs.',
            'Designated Car-2-Go Space(s): The community has designated spaces for Car-2-Go cars.',
            'Dog Park/Play Area: A shared park for dogs to exercise and play off-leash.',
            'Electronic Payments: The community accepts electronic payment for bills and fees.',
            'Equestrian Community: A place where horses can exercise or riders congregate.',
            'Fishing: The community has places to go fishing.',
            'Fitness Center: The community has a fitness center.',
            'Game Room: The community has a shared room for games such as pool, ping pong, etc.',
            'Garage Parking: The community has a shared garage for parking.',
            'Gated: The community is gated.',
            'General Aircraft Airport: The community has a shared airport for general aircraft.',
            'Golf Course: The property falls inside a community with a golf course.',
            'Google Fiber: The community has access to Google Fiber high-speed Internet.',
            'Health Club Discount: The community comes with a discount to a health/fitness club.',
            'High Speed Internet Access: The community has access to high-speed Internet.',
            'Hot Tub Community: The community has a shared hot tub.',
            'Housekeeping: The community has a shared housekeeping service available.',
            'Kitchen Facilities: The community has a shared kitchen for cooking or food preparation.',
            'Lake: The community has a lake.',
            'Laundry Facility(s): The community has a shared laundry facility.',
            'Laundry Service: The community has a laundry service available.',
            'Library: The community has a shared area for books and reading.',
            'Lounge: The community has a shared area for sitting and lounging.',
            'Maintenance On-Site: The community has on-site maintenance for repairs.',
            'Media Center/Movie Theatre: The community has a shared media center or movie theatre.',
            'Mini-Golf: The community has a shared miniature golf course.',
            'Nest Thermostat: The community provides a Nest Thermostat for residents.',
            'Night Security/Patrol: The community provides night security/patrol service.',
            'On-Site Retail: The community has retail stores on site.',
            'Online Services: The community offers online services.',
            'Package Service: The community offers a package service for holding packages.',
            'Park: The community has a park.',
            'Pet Amenities: The community offers amenities for pets.',
            'Picnic Area: The community has a shared picnic area.',
            'Planned Social Activities: The community has regular, planned social activities.',
            'Playground: The community has a playground.',
            'Pool: The community has a pool.',
            'Professional Fitness Center: The community has a professional fitness center.',
            'Property Manager On-Site: The community has a property manager on-site.',
            'Putting Green: The community has a putting green for practicing golf.',
            'Racquetball: The community has racquetball facilities.',
            'Recycling Area/Center: The community has a shared recycling area.',
            'Restaurant: The community has a restaurant.',
            'Rooftop Lounge: The community has a rooftop lounge.',
            'Room Service: The community offers room service.',
            'Sauna: The community has a shared sauna.',
            'Shopping Mall: The community has a shopping mall.',
            'Sidewalks: The community streets have sidewalks.',
            'Smart Car Charging: The community offers charging stations for electric cars.',
            'Spa/Hot Tub: The community has a shared spa/hot tub.',
            'Sport Court(s)/Facility: The community has a shared sport court/facility.',
            'Stable(s): The community has horse stables.',
            'Storage: The community has on-site storage for residents.',
            'Street Lights: The community streets have lighting.',
            'Suburban: The community is in a suburban setting.',
            'Sundeck: The community has a shared sundeck.',
            'Tanning Salon: The community has a shared tanning salon.',
            'Tenant Access Cargo Elevator: The community has a shared cargo elevator.',
            'Tennis Court(s): The community has shared tennis courts.',
            'Trash Pickup - Door to Door: The community offers door-to-door trash pickup.',
            'Underground Utilities: The community provides underground utilities.',
            'U-Verse: The community provides U-Verse Internet/Cable service.',
            'Valet Parking: The community offers valet parking.',
            'Walk/Bike/Hike/Jog Trail(s): The community has trails for walking, biking, hiking, or jogging.'
        ]
    },
    communityWebSite: {
        title: 'Community Website Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `(Community information only. No Agent Information Allowed.)`
    },
    guestAccommodations: {
        title: 'Guest Accommodation Desc Help',
        ruleHelp: ['Guest Accommodaton Desc is required.'],
        generalHelpDesc: `Guest Accommodation Desc.`
    },
    guestBeds: {
        title: '# Guest Beds Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `Num Guest Beds`
    },
    guestFullBaths: {
        title: '# Guest Full Baths Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `Num Guest Full Baths`
    },
    guestHalfBaths: {
        title: '# Guest Half Baths Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `Num Guest Half Baths`
    },
    distanceToUTShuttle: {
        title: 'Distance To UT Shuttle Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `Distance To UT Shuttle`
    },
    distanceToMetro: {
        title: 'Distance to Metro Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `Distance to Metro`
    },
    distanceToLightRail: {
        title: 'Distance to Light Rail Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `Distance to Light Rail`
    },
    HorseAmenities: {
        title: 'Horse Amenities Help',
        ruleHelp: ['Horse Amenities is required.'],
        generalHelpDesc: `A list of horse amenities on the lot or in the community. <a href="https://ddwiki.reso.org/display/DDW17/HorseAmenities+Field" target="_blank" rel="noopener noreferrer">RESo HorseAmenities</a>.`,
        generalHelp: [
            'Arena: The property allows for horses and has an arena.',
            'Bridle Path: A path or track used for horseback riding.',
            'Barn: The property allows horses and has a barn.',
            'Boarding Facilities: The property had horse boarding facilities.',
            'Corral(s): The property allows horses and has one or more corrals.',
            'Hay Storage: The property allows horses and has hay storage.',
            'Paddocks: The property allows horses and has an enclosed living are for your horse(s). A paddock is also known as a sacrifice area which got its name because the owner was sacrificing some of their land for the benefit of the horse.',
            'Palpation Chute: A portion of the livestock chute where the animal is held for examination or other purposes.',
            'Pasture: The property includes or has access to a pasture for horses.',
            'Riding Trail: The property includes or has access to a riding trail(s).',
            'Round Pen: The property includes or has access to a round enclosure used for horse training.',
            'Shaving Bin: The property includes or has access to a storage container for wood shavings that are use as ground cover for horses.',
            'Stable(s): The property includes or has access to horse stable(s).',
            'Tack Room: The property includes or has access to a room to store equipment such as saddles, stirrups, bridles, halters, reins, bits, harnesses, martingales, breastplates, etc.',
            'Trailer Storage: The property includes or has access to a place to store a horse trailer.',
            'Wash Rack: The property includes or has access to a rack used to confine/restrain a horse for purposes of washing the horse.'
        ]
    },
    InteriorFeatures: {
        title: 'Interior Features Help',
        ruleHelp: ['Interior Features is required.'],
        generalHelpDesc: `A list of features or description of the interior of the property included in the sale/lease <a href="https://ddwiki.reso.org/display/DDW17/InteriorFeatures+Field" target="_blank" rel="noopener noreferrer">RESo InteriorFeatures</a>.`,
        generalHelp: [
            '2 Primary Baths: The property has two primary bathrooms.',
            '2 Primary Suites: Having two primary bedrooms/suites to accommodate extended family.',
            'Bar: A built-in or movable fixture for the storage, preparation, serving and/or consumption of drinks.',
            'Bidet: A type of sink designed to wash the undercarriage of the human body.',
            'Bookcases: Shelfs for books or other objects which may or may not be built into the property.',
            'Breakfast Bar: A surface designed for eating, which is typically smaller than dining table and attached to the other kitchen surfaces.',
            'Built-in Features: Some features are physically attached to the structure.',
            'Cedar Closet(s): A closet that is partially or fully lined with cedar wood.',
            'Ceiling Fan(s): The room(s) have fans that are mounted from the ceiling.',
            'Ceiling(s)-Beamed: A property where the room, or rooms, have exposed beams across the ceiling.',
            "Ceiling(s)-Cathedral: A type of vaulted ceiling that is typically higher than normal ceilings and has a slant or curve to reach it's upper most point, which tends to be equal distance from the two shorter walls in the room.",
            'Ceiling(s)-Coffered: A ceiling with multiple decorative indentations, trays or sunken panels.',
            'Ceiling(s)-High: The ceiling height is greater than what might be considered a normal celling height.',
            'High Speed Internet: The property has access to high speed internet service, but may or may not be wired and/or connected to that service.',
            'Ceiling(s)-Tray: A ceiling with a inverted tray or recessed area, often rectangular, that adds depth and interest.',
            'Ceiling(s)-Vaulted: From the Italian word Volta, is typically a high celling with no attic between the ceiling and the roof. When a vaulted celling has two angles that meet in the center of the room, you may use Cathedral Ceiling(s).',
            'Central Vacuum: A built-in vacuum that typically consists of a power/collection unit that is typically install in a garage or closet, tubing from the power unit to rooms thought the house, and wall mounted receptacles for the connection of a movable vacuum hose.',
            'Chandelier: A decorative lighting fixture that typically branches out with several lights (or candles) with other decorative components such as glass, crystal or other reflective or light enhancing materials.',
            'Crown Molding: A decorative trim covering the seam between the ceiling and walls.',
            'Double Vanity: Bathroom cabinetry with two built-in sinks.',
            'Dry Bar: A built-in or movable fixture for the storage, preparation, serving and consumption of drinks that does not have a water supply or sink.',
            'Dumbwaiter: A small elevator, typically for carrying food between floors in a structure.',
            'Eat-in Kitchen: A kitchen that has been designed to accommodate dining.',
            'Dryer-Electric Hookup: The property has a hookup for an electric dryer.',
            'Dryer-Gas Hookup: The property has a hookup for a gas dryer.',
            'Elevator: A platform or compartment housed within a shaft for raising or lowering people or objects.',
            'Entrance Foyer: A room or hall at the entrance leading to other parts of the structure. ',
            'French Doors: Usually a pair of doors of light construction with glass panes throughout its length.',
            'In-Law Floorplan: The structure has an area within that has the characteristics of an independent apartment. Typically with a living area, kitchen, bedroom and bathroom, and in-law floor plan is not necessarily an Accessory Dwelling Unit (ADU).',
            'Intercom: An electrical device allowing one-way or two-way communication, such as a PA or paging system.',
            'Interior Steps: Any number of steps, up or down, on the inside of the dwelling.',
            'Kitchen Island: A separate counter surface in a kitchen that is not attached to other surfaces or to a wall. A kitchen island may or may not include a sink, stove or other fixtures.',
            'Low Flow Plumbing Fixtures: Some or all of the fixtures are designed to save water.',
            'Natural Woodwork: The property or room has features made from real wood.',
            'No Interior Steps: No existing stairs or steps inside the home/dwelling.',
            'Open Floorplan: A generic design term for a floor plan that makes use of large open spaces and avoids the use of small enclosed spaces.',
            'Pantry: A small room or closet where food, dishes and utensils are stored.',
            'Primary Bedroom on Main: The primary bedroom is on the main level of the structure.',
            'Recessed Lighting: A light fixture installed into a hallow opening in the celling.',
            'Sauna: A small room or separate structure designed to produce heat, wet with steam, or dry, to induce perspiration.',
            'Smart Home: Smart Home features are a generic term for electronic automation of features such as lighting, heating/cooling, security and other amenities. The features are typically linked though an app or software via one or more third party services. The features are also known for their convenience and ',
            'energy efficiency.',
            'Smart Thermostat: A heating/cooling control unit that has convenience and energy saving aspects. A smart thermostat may also integrate with a larger smart home system and typically operates through a third party service.',
            'Soaking Tub: A bath tub that is typically deeper and may be shorter than traditional tubs.',
            'Solar Tube(s): A reflective tube that extends from a light gathering surface on the roof of the structure down into a room where the outside light is distributed.',
            'Sound System: The includes a sound system. This typically includes in-wall wiring and recessed/built-in speakers and a built in location for the amplifier and other audio equipment.',
            'Stackable W/D Connections: The property has a stacked cloths washer and dryer connections.',
            'Storage: The property or room has storage space.',
            'Tile Counters: The property or room has counters that are made of some type of tile.  Track Lighting: A type of lighting where the light fixtures are mounted on a track allowing for adjustment of the position of the lights.',
            'Two Primary Closets: The room(s) have two separate closets.',
            'Walk-In Closet(s): A closet that is a small room with an entryway.',
            'WaterSense Fixture(s): Water fixtures that are backed by independent, third–party certification and meet EPA’s specifications for water efficiency and performance.',
            'Wet Bar: Commonly a built-in fixture for the storage, preparation, serving and/or consumption of drinks that has a faucet and sink.',
            'Wired for Data: The property has been wired for data, typically Category 5 or 6 wiring for the support of ethernet data communications.',
            'Wired for Sound: The property has been wired for a built-in sound system. This typically includes in-wall wiring and recessed/built-in speakers and a location for audio equipment. The wiring is in place, but equipment may not be included.'
        ]
    },
    Appliances: {
        title: 'Appliances Help',
        ruleHelp: ['Appliances is required.'],
        generalHelpDesc: `Appliances and/or equipment in or around the house that may convey with the sale of the property. Please note: only the contract signed by each party is enforceable <a href="https://ddwiki.reso.org/display/DDW17/Appliances+Field" target="_blank" rel="noopener noreferrer">RESo Appliances</a>.`,
        generalHelp: [
            'Bar Fridge: A refrigerator that is sized and/or built to be part of a bar.',
            'Built-In Electric Oven: A built-in electric oven.',
            'Built-In Electric Range: A built-in electric range.',
            'Built-In Freezer: A built-in freezer.',
            'Built-In Gas Oven: A built-in gas oven.',
            'Built-In Gas Range: A built-in gas range.',
            'Built-In Oven(s): Ovens that are built into a special tall unit for that purpose to provide an ergonomically convenient working height.',
            'Built-In Range: A built-in range where the fuel type is not specified.',
            'Built-In Refrigerator: A built-in refrigerator.',
            'Convection Oven: A convection oven (also known as a fan-assisted oven or simply a fan oven) is an oven that has fans to circulate air around food.',
            'Cooktop: A kitchen stove, often called simply a stove or a cooker, is a kitchen appliance designed for the purpose of cooking food. Kitchen stoves rely on the application of direct heat for the cooking process.',
            'Dishwasher: A dishwasher is a mechanical device for cleaning dishware and cutlery.',
            "Disposal: A garbage disposal unit (also known as a garbage disposal, waste disposal unit, garbage disposer, or in Canadian English a garburator) is a device, usually electrically powered, installed under a kitchen sink between the sink's drain and the ",
            'trap. The disposal unit shreds food waste into pieces small enough, generally less than 2 mm (0.079 in), to pass through plumbing.',
            'Down Draft: A vent that is part of the surface of a cook top that has a fan which sucks cooking fumes/smoke down. This is an alternative to a hooded cooktop/range.',
            'Dryer: A cloths dryer.',
            'Electric Cooktop: A cooktop or stove that produces heat by way of electricity rather than gas. An induction cooktop is electric, but not all electric cooktops are induction.',
            'Electric Range: An oven and cooktop that generates heat by way of electricity.',
            'ENERGY STAR Qualified Appliances: The property includes Energy Star qualified appliances.',
            'ENERGY STAR Qualified Dishwasher: The property includes an Energy Star qualified dishwasher.',
            'ENERGY STAR Qualified Dryer: The property includes an Energy Star qualified cloths dryer.',
            'ENERGY STAR Qualified Freezer: The property includes an Energy Star qualified freezer.',
            'ENERGY STAR Qualified Refrigerator: The property includes an Energy Star qualified refrigerator.',
            'ENERGY STAR Qualified Washer: The property includes an Energy Star qualified cloths washer.',
            'ENERGY STAR Qualified Water Heater: The property includes an Energy Star qualified water heater.',
            'Exhaust Fan: The cooktop has an exhaust fan.',
            'Freezer: The property includes a freezer.',
            'Freezer Free-Standing: The freezer is free standing and not built-in.',
            'Gas Cooktop: A cooktop or stove that produces heat by way of gas rather than electricity. An induction cooktop is electric, but not all electric cooktops are induction.',
            'Gas Range: An oven and cooktop that generates heat by way of gas.',
            'Humidifier: The property includes a humidity control device or system.',
            'Ice Maker: The property includes an ice maker.',
            'Indoor Grill: The property has an indoor grill.',
            'Induction Cooktop: The electric cooktop is based on magnetic induction rather than heating coils.',
            'Instant Hot Water: The property has a circulatory or instant hot water system.',
            'Microwave: The property includes a microwave.',
            'Oven: The property includes an oven.',
            'Oven Electric: An oven that is heated by electricity, typically by way of heating coils.',
            'Oven Free-Standing Electric: The oven is free standing, not built-in, and uses electricity to produce heat.',
            'Oven Free-Standing Gas: The oven is free standing, not built-in, and uses gas to produce heat.',
            'Oven Gas: An oven that is heated by gas.',
            'Oven-Double: A built-in oven fixture that has either two ovens, or one oven and one microwave oven. It is usually built into the kitchen cabinet.',
            'Plumbed For Ice Maker: The property has plumbing for an ice maker.',
            'Portable Dishwasher: The property includes a portable dishwasher.',
            'Propane Cooktop: The gas cooktop uses propane as its fuel and either has a local tank or runs on a house wide propane system.',
            'Range: The property includes a range, which is a single unit that has both an oven and a cooktop.',
            'Range Free-Standing Electric: The range is free standing, not built-in, and uses electricity to produce heat for its oven and cooktop.',
            'Range Free-Standing: The range is free standing, not built-in.',
            'Range Free-Standing Gas: The range is free standing, not built-in, and uses gas to produce heat for its oven and cooktop.',
            'Range Hood: The range has a hooded exhaust.',
            'Refrigerator: The property includes a refrigerator.',
            'Refrigerator Free-Standing: The refrigerator is free-standing, not built-in.',
            'Self Cleaning Oven: The oven included with the property has a self-cleaning feature.',
            'Solar Hot Water: The hot water heater has either a passive or active solar component.',
            'Stainless Steel Appliance(s): Some or all of the appliances included in the property are stainless steal.',
            'Tankless Water Heater: A tankless water heater is included with the property.',
            'Trash Compactor: The property has a trash compactor.',
            'Vented Exhaust Fan: The cooktop has an exhaust fan that is vented.',
            'Warming Drawer: The property has a warming drawer.',
            'Washer: The property includes a cloths washer.',
            'Washer/Dryer: The property includes a cloths washer and dryer.',
            'Washer/Dryer Stacked: The property has a stacked cloths washer and dryer.',
            'Water Heater-Electric: The property has an electric water heater.',
            'Water Heater-Gas: The property has a gas water heater.',
            'Water Purifier: The property has a water purifier.',
            'Water Purifier Owned: The property has a water purifier that is owned and not rented/leased.',
            'Water Purifier Rented: The property has a water purifier that is on a rental or lease agreement.',
            'Water Softener: The property has a water softening system.',
            'Water Softener Owned: The property has a water softening system that is owned and not rented/leased.',
            'Water Softener Rented: The property has a water softening system that is on a rental or lease agreement.',
            'Wine Cooler: The property includes a wine cooler.',
            'Wine Refrigerator: The property includes a wine refrigerator.'
        ]
    },
    ExteriorFeatures: {
        title: 'Exterior Features Help',
        ruleHelp: ['Exterior Features is required.'],
        generalHelpDesc: `A list of features or description of the exterior of the property included in the sale/lease. <a href="https://ddwiki.reso.org/display/DDW17/ExteriorFeatures+Field" target="_blank" rel="noopener noreferrer">RESo ExteriorFeatures</a>.`,
        generalHelp: [
            'Balcony: The property has an exterior balcony.',
            'Barbecue: The property has an outdoors barbeque.',
            'Basketball Court: The property has a basketball court.',
            'Boat Dock - Private: A dock attached with the property designated only for the owner of the land.',
            'Boat Dock - Shared: The property includes a dock.',
            'Boat Lift: The property has a boat lift, ship lift, or lift lock, which is a machine for transporting boats between water at two different elevations, and is an alternative to the canal lock and the canal inclined plane.',
            'Boat Lock: That property has a boat lock. Boat locks are the infrastructure that lifts a boat from a lower body of water to a higher body of water without ever removing it from the water.',
            'Boat Ramp: The property has a boat ramp, also known as a slipway, is a ramp on the shore by which ships or boats can be moved to and from the water.',
            'Boat Slip: The property includes a boat slip.',
            'Courtyard-Covered: The property has a covered courtyard.',
            'Courtyard-Uncovered: The property has an uncovered courtyard.',
            'Dog Run: The property has a dog run. A dog run is a dedicated area (usually enclosed by a fence) of a property where dogs may exercise, play, or lie down.',
            'Electric Car Plug-In: A station to recharge cars that run on electricity or solar power, i.e. hybrid vehicles.',
            'Electric Grill: The property has an outdoor electric grill.',
            'Exterior Steps: Any number of steps, up or down, on the outside of the dwelling.',
            'Garden: The property has a garden.',
            'Gas Grill: The property has an outdoor gas grill.',
            'Gray Water System: The property has a grey water system.',
            "Gutters-Full: The property has rain gutter devices installed on all the home's roof edges to divert rain away from walls to downspouts that divert water away from the home's foundation.",
            "Gutters-Partial: Rain gutter devices installed only on some of the home's roof edges (typically “front only” or only over doors) to divert rain off of those roof areas to downspouts that take it to the ground.",
            'Kennel: The property has a kennel.',
            'Lighting: The property has exterior lighting.',
            'Misting System: The property has a misting system, a fixture that sprays mists of water for dust control or to help cool down a patio/porch and its occupants.',
            'No Exterior Steps: No existing stairs or steps outside or around the home/dwelling.',
            'Outdoor Grill: The property has an outdoor grill.',
            'Permeable Paving: The property has preamble paving that allows fluids to run through the paving to the below ground or channeling.',
            'Pest Tubes in Walls: A series of small, connectorless, plastic tubes installed in the wall during construction that are periodically (usually through annual contract) injected with a small amount of insecticide as a means of treating or preventing some ',
            'pest activity.',
            'Playground: The property has a playground.',
            'Private Entrance: The property has a private entrance.',
            'Private Yard: The property has a private yard.',
            'Restricted Access: The property has resricted access.',
            'RV Hookup: The property has hookups for recreational vehicles.',
            'Satellite Dish Leased: The property comes with a leased satellite dish.',
            'Satellite Dish Owned: The property comes with an owned satellite dish.',
            'Sport Court: The property has a shared sport court(s)/facility that can be used for various sports. Ex. Pickleball.',
            'Tennis Court(s): The property has one or more tennis courts.'
        ]
    },
    WindowFeatures: {
        title: 'Window Features Help',
        ruleHelp: ['Window Features is required.'],
        generalHelpDesc: `A list of features or description of the windows included in the sale/lease. <a href="https://ddwiki.reso.org/display/DDW17/WindowFeatures+Field" target="_blank" rel="noopener noreferrer">RESo WindowFeatures</a>.`,
        generalHelp: [
            'Aluminum Frames: The windows have aluminum frames.',
            'Bay Window(s): The property has one or more bay windows.',
            'Blinds: The property has window blinds.',
            'Display Window(s): The property has one or more windows that would normally be used to display goods or products.',
            'Drapes: The property has drapes.',
            'Dual Pane Windows: The property has windows with two panes of glass.',
            'ENERGY STAR Qualified Windows: The property has ENERGY STAR Qualified windows.',
            'Garden Window(s): The property has one or more garden windows.',
            'Insulated Windows: The property has insulated windows.',
            'Low Emissivity Windows: The property has low emissivity windows.',
            'Plantation Shutters: The property has plantation shutters.',
            'Screens: The property has screens.',
            'Shutters: The property has shutters.',
            'Skylight: The property has skylight(s).',
            'Solar Screens: The property has solar screens.',
            'Storm Window(s): The property has storm window(s).',
            'Tinted Windows: The property has tinted windows, windows that have a coating applied to them to block out sunlight and harmful UV rays.',
            'Triple Pane Windows: The property has triple pane windows, made with three panes of glass. Each of the 3 panes has a spacer around the edges to give them a uniform space between layers. A seal between each pane makes the windows airtight and allows for pockets of gas to fill the space for improved insulation and makes for a more energy efficient window.',
            'Vinyl Windows: A window whose frame materials are made of vinyl.',
            'Window Coverings: The property has window coverings, material used to cover a window to manage sunlight, to provide additional weatherproofing, to ensure privacy or sometimes security, or for purely decorative purposes.',
            'Window Treatments: The property has window treatments, interior decoration (curtains, blinds, valences, etc) for a window or window frame.',
            'Wood Frames: The property has wood framed windows.'
        ]
    },
    SecurityFeatures: {
        title: 'Security Features Help',
        ruleHelp: ['Security Features is required.'],
        generalHelpDesc: `A list describing the security features included in the sale/lease. <a href="https://ddwiki.reso.org/display/DDW17/SecurityFeatures+Field" target="_blank" rel="noopener noreferrer">RESo SecurityFeatures</a>.`,
        generalHelp: [
            '24 Hour Security: The property has 24 hour security.',
            'Building Security: The property has building security.',
            'Carbon Monoxide Detector(s): The property has carbon monoxide detector(s).',
            'Closed Circuit Camera(s): The property has closed circuit camera(s).',
            'Fire Alarm: The property has fire alarm(s).',
            'Fire Escape: The property has a fire escape.',
            'Fire Sprinkler System: The property has a fire sprinkler system.',
            'Firewall(s): The property has firewall(s).',
            'Gated with Guard: The property is in a gated community/area with guard service.',
            'Key Card Entry: The property or community has key card entry.',
            'Panic Alarm: The property has a panic alarm.',
            'Prewired: The property is prewired for a security system.',
            'Secured Garage/Parking: The property has a secured garage or parking area.',
            'Security Fence: The property has a security fence.',
            'Security Guard: The property or community has a security guard.',
            'Security Lights: The property has security lights.',
            'Security Service: The property has a security service.',
            'Security System: The property has a security system.',
            'Security System Leased: The property has a leased security system.',
            'Security System Owned: The property has an owned security system.',
            'Smoke Detector(s): The property has smoke detector(s).',
            'Varies By Unit: The security features vary from unit to unit.',
            'Window Bars: The property has window bars.',
            'Window Bars with Quick Release: The property has window bars with a quick release mechanism.'
        ]
    },
    SpaFeatures: {
        title: 'Spa Features Help',
        generalHelpDesc: `A list of features or description of the spa included in the sale/lease. <a href="https://ddwiki.reso.org/display/DDW17/SpaFeatures+Field" target="_blank" rel="noopener noreferrer">RESo SpaFeatures</a>.`,
        generalHelp: [
            'Above Ground: The spa is not built into the ground.',
            'Bath: The bath has a built in spa/jets.',
            'Fiberglass: The spa is lined or made of fiberglass.',
            'Gunite: The spa is lined with gunite.',
            'Heated: The spa is heated.',
            'Hot Tub: A spa and/or hot tub on the property.',
            'In Ground: The spa is built into the ground.'
        ]
    },
    AccessibilityFeatures: {
        title: 'Accessibility Features Help',
        ruleHelp: ['Accessibility Features is required.'],
        generalHelpDesc: `A list of features or description of the spa included in the sale/lease. <a href="https://ddwiki.reso.org/display/DDW17/AccessibilityFeatures+Field" target="_blank" rel="noopener noreferrer">RESo AccessibilityFeatures</a>.`,
        generalHelp: [
            `Adaptable Bathroom Walls: Reinforced main bathroom walls, including bath or shower, to permit installation of grab bars (with shear force of 250 pounds) and/or fixtures in the future. This is required to be considered Enhanced Accessible.`,
            `Adaptable For Elevator: Stacked closets in a multi-story house for possible future conversion to an elevator.`,
            `Approach with Ramp: A minimum of one entrance to the structure with clear, evenly-paved walkway from parking area or pedestrian arrival area; Path of travel does not include a running slope in excess of 1:12 (8.33%); a cross slope exceeding 1:50 (2%); nor level changes of more than 1/2 inch; if slope is over 5%, handrails are required. Level landing; 32 inch clear width opening doors; and adequate lighting on pathway and landing. This is required to be considered "Visitable".`,
            `Bedroom: Bedroom has adequate turnaround of 60 inches or other approved turnaround configuration; Closet doors have 32 inch clearance. Accessible environmental controls. Multiple lighting fixtures. This is required to be considered Enhanced Accessible. Optional: Some lower-height storage in closet. Remote control of lighting and environmental controls.`,
            `Ceiling Track: Track installed in ceiling for lift chair (Hoyer lift).`,
            `Central Living Area: Central Living Area includes: Common Area, hallway(s), full or 3/4 bathroom, kitchen, at least one bedroom, access to environmental controls, and access to floors above main floor, if necessary.`,
            `Closets: Closet doors are 32” clearance throughout Central Living Area.`,
            `Common Area: Common Area, used for entertaining guests, is level, with 36-inch passage through and around the space. Required to be considered Visitable.`,
            `Customized Wheelchair Accessible: Customized accessibility for specific size or style of wheelchair or scooter.`,
            `Doors: Minimum 32 inches clear passage; levered handle; threshold, if present, maximum 1/2-inch, but beveled on both sides when over 1/4 inch. Required to be considered Visitable or Enhanced Accessible.`,
            `Electronic Environmental Controls: Thermostats and security system controls located on floor with central living area. Control devices for light switches and thermostats at 42-48 inches height off floor and side- to-side. Electrical plugs minimum of 18 inches above floor. This is required to be considered Enhanced Accessible. Optional: Rocker-style light switches; Lighted switches; Automatic/remote control for environmental controls.`,
            `Elevator Installed: Elevator with minimum 32" door and minimum 36" x 48" turning radius.`,
            `Enhanced Accessibility: The Central Living Area is fully accessible for lifelong living by all residents, no matter their ability. A person in a wheel chair or with other disability is able to perform all personal and housekeeping tasks. Persons without disabilities are also able to perform basic tasks with greater ease. To be considered "Enhanced Accessible" the home also includes all "Visitable" features.`,
            `Entrance: Entrance door is a minimum of 32 inches wide; threshold , when present, maximum 1/2-inch, but when over 1/4-inch, is beveled on both sides. The entry door has lever handle for egress. This is required to be considered Visitable. Optional: Entryway is covered; Bench near outside entry door; Motion-detection outside lights. Accessible peephole or other method for inside viewing of anyone outside the entry door. House number easily visible from street by emergency responders.`,
            `Exterior Wheelchair Lift: Mechanical wheelchair lift is installed outside the home to facilitate barrier-free approach.`,
            `For Hearing-Impairment: Home is wired for flashing lights and/or vibrating smoke alarm, door bell, other alerting features.`,
            `Full Bath: Bathroom has adequate turnaround: 60 inches or other approved turnaround configuration. Accessible bathing area: Roll-in shower or space for shower chair or transfer bench in bathtub. Slip-resistant surface on bathroom floor and bathtub/shower. Roll-under or side-access to sink, with padded trap. Lighting directly over shower/bathing areas, in addition to general bathroom lighting. This is required to be considered Enhanced Accessible. Optional: Removable cabinet doors and base under sink. Grab bars with shear force of 250 pounds, installed around toilet and shower/tub, with proper backing. Hand-held and/or height-adjustable shower head; automatic water temperature controlled (anti-scald) tub/shower; offset tub/shower `,
            `controls toward front edge of tub/shower for easy access. Raised toilet (17-19 inches minimum).`,
            `Fully Accessible: The property is fully accessible for lifelong living by all residents, no matter their ability. A person in a wheel chair or with other disability is able to perform all personal and housekeeping tasks. Persons without disabilities are also able to perform basic tasks with greater ease. To be considered "Enhanced Accessible" the home also includes all "Visitable" features.`,
            `Grip-Accessible Features: All doors, faucets and other mechanisms throughout central living area are lever, hands-free or other style that can be controlled with a closed, clenched fist or weak hands. This is required to be considered Enhanced Accessible. Optional: Wire pull (D-ring) handles or equivalent or easy touch latches on cabinets and drawers.`,
            `Hallway(s): Hallway is minimum 36 inches, preferred 42 inches wide (or adequate alternative based on individual configuration). At least one lighting fixture is present.`,
            `Hand Rails: The property contains hand rails, poles drilled on the side of a wall to help prevent a fall and aid in walking or transports.`,
            `Kitchen: 40" clear turn-around, or 36" clear with clear under-counter space for T-turn space in kitchen, unimpeded by fixtures. Roll-under/adaptable sink with padded trap or side-access to sink. Roll-out shelves in at least 50% of lower cabinets, Roll-under work area (36" clearance). Lighting fixtures directed over all task areas with adaptable control. This is required to be considered Enhanced Accessible. Optional: Adaptable under-sink cabinet with removable doors and cabinet base. Accessible features for upper kitchen cabinets. Space for side-by-side refrigerator (minimum 36 inches); Contrasting color counter edges for vison accessibility.`,
            `Kitchen Appliances: Stove controls in front or side, at counter top height; Oven with side-access door at counter level; Microwave is at counter level. This is required to be considered Enhanced Accessible. Optional: Raised dishwasher. Microwave has clear work area below or to the right side.`,
            `Lower Fixtures: Refers to easily accessed switches for smaller residents or wheelchair access.`,
            `Reinforced Floors: Reinforced floors for bariatric needs, power wheelchairs, therapeutic tub or heavy medical equipment.`,
            `Safe Emergency Egress from Home: Minimum two, no-step, accessible egresses from Central Living Area. Window locks are 19 to 54 inches from the floor and can be opened with a closed fist. Emergency egress windows in sleeping areas require minimal effort to open. This is required to be considered Enhanced Accessible.`,
            `Smart Technology: Smart Home (computer-controlled) and/or smart products— for example, voice activated controls, voice reminder, remote monitoring of individuals with dementia.`,
            `Stair Lift: Stair lift with motorized rail to climb interior or exterior stairway installed professionally.`,
            `Stairway: Handrails on both sides of stairs, extended when possible, with shear force of 250 pounds. Interior and exterior stairs have adequate number of light fixtures for full coverage. Non-slip stair treads. If stairs are carpeted, covering is non-moveable, low-pile carpet. This is required to be considered Enhanced Accessible. Optional: Stair treads are in high contrast colors for increased visibility.`,
            `Standby Generator: Backup generator for refrigeration of medications, life-sustaining medical equipment or essential room temperature control.`,
            `Therapeutic Whirlpool: Therapeutic whirlpool, properly installed.`,
            `Visitable: The home is “visitable” for all guests: a person in a wheel chair can easily enter the home and access the main Common Area, a half-bathroom at minimum, and the hall leading to that bathroom.`,
            `Visitor Bathroom: Bathroom that is closest to Common Area. Minimum half bath. Door has minimum 32-inch clear width opening; lever handles. Minimum 60-inch turnaround or other approved turnaround configuration (30" x 48" clear space if door opens out.). Grab bar installed in toilet area with proper blocking. This is required to be considered Visitable.`,
            `Walker-Accessible Stairs: Treads are minimum 25 inches deep, with maximum 4 inches rise, minimum 36 inches wide. May be a custom feature in addition to approach with ramp.`,
            `Washer/Dryer: Raised clothes washer and/or dryer, front controls, side opening, both open to center.`
        ]
    },
    FireplaceFeatures: {
        title: 'Fireplace Features Help',
        ruleHelp: ['Fireplace Features is required.'],
        generalHelpDesc: `A list of features or description of the fireplace(s) included in the sale/lease <a href="https://ddwiki.reso.org/display/DDW17/FireplaceFeatures+Field" target="_blank" rel="noopener noreferrer">RESo FireplaceFeatures</a>.`,
        generalHelp: [
            'Basement: There is a fireplace in the basement.',
            'Bathroom: The property includes a bathroom fireplace.',
            'Bedroom: The property has a bedroom fireplace.',
            'Blower Fan: The fireplace has a blower fan.',
            'Circulating: The fireplace has a circulation system.',
            'Decorative: The property has a decorative fireplace.',
            'Den: The property has a fireplace in the den.',
            'Dining Room: The property has a fireplace in the dining room.',
            'Double Sided: The property has a double sided fireplace. Double sided fireplaces often have openings in adjacent rooms.',
            'Electric: The fireplace is electric.',
            'EPA Cert Wood Stove: The property has an EPA certified wood stove.',
            'EPA Qualified Fireplace: The property has an EPA certified fireplace.',
            'Factory Built: The fireplace is factory built and later installed into the property.',
            'Family Room: There is a fireplace in the family room.',
            'Fire Pit: The property has a fire pit.',
            'Free Standing: The fireplace is free standing, rather than built-in.',
            'Gas: The fireplace burns gas.',
            'Gas Log: The gas fireplace has a gas log.',
            'Gas Starter: The fireplace has a gas started, but also burns wood or other fuels.',
            'Glass Doors: The fireplace has glass doors.',
            'Great Room: There is a fireplace in the great room.',
            'Heatilator: The fireplace has a built in ventilation system used to circulate heat.',
            'Insert: A fireplace insert is a device inserted into an existing masonry or prefabricated fireplace. Inserts are used for their aesthetic, insulating, circulating or other features.',
            'Kitchen: The property has a fireplace in the kitchen.',
            'Library: The property has a fireplace in the library.',
            'Living Room: The property has a fireplace in the living room.',
            'Masonry: The fireplace is made of masonry.',
            'Metal: The fireplace is make of metal.',
            'Outside: The property has an outdoor fireplace.',
            'Pellet Stove: The property has a stove that burns compressed wood or biomass pellets to generate heat.',
            'Primary Bedroom: The property has a fireplace in the primary bedroom.',
            'Propane: The fireplace burns propane.',
            'Raised Hearth: The fireplace has a raised hearth.',
            'Recreation Room: The property has a fireplace in the recreation room.',
            'Sealed Combustion: The fireplace has sealed combustion chamber.',
            'See Through: The property has a see-through fireplace, usually positioned between two rooms.',
            'Stone: The property has a fireplace made with stone.',
            'Ventless: The property has a ventless fireplace.',
            'Zero Clearance: The property has a zero clearance fireplace. Zero clearance fireplaces are built to be placed almost directly against combustible materials like wood, walls, or paneling.'
        ]
    },
    PoolFeatures: {
        title: 'Pool Features Help',
        ruleHelp: ['Pool Features is required.'],
        generalHelpDesc: `A list of features or description of the private pool included in the sale/lease.<br/> NOTE: This field is used to describe Pool Features for a pool owned by an individual and NOT a community pool. To enter a community pool for the listing, select "Pool" under the Community Features field.<br/> <a href="https://ddwiki.reso.org/display/DDW17/PoolFeatures+Field" target="_blank" rel="noopener noreferrer">RESo PoolFeatures</a>.`,
        generalHelp: [
            'Above Ground: The pool is above ground.',
            'Black Bottom: The pool has a black bottom.',
            'Cabana: The pool has a cabana.',
            'Diving Board: The pool has a diving board.',
            'Electric Heat: The pool is heated by electricity.',
            'ENERGY STAR Qualified Pool Pump: The pool has an ENERGY STAR Qualified pool pump.',
            'Fenced: The pool is fenced.',
            'Fiberglass: The pool is made of or lined with fiberglass.',
            'Filtered: The pool has a filtration system.',
            'Gunite: The pool has a gunite surface.',
            'Heated: The pool is heated.',
            'In Ground: The pool is built into the ground.',
            'Indoor: The pool is indoors or within a structure.',
            'Infinity: Also named a negative edge, zero edge or infinity edge, an infinity pool has one or more edges where water flows over the edge creating a visual effect of water with no boundary.',
            'Lap: The pool is specifically designed for swimming laps.',
            'Liner: The pool has a liner.',
            'Outdoor Pool: The pool is outdoors.',
            'Pool Cover: The pool has a cover.',
            'Pool Sweep: The pool has an automatic sweep or cleaner.',
            'Pool/Spa Combo: The pool includes a spa.',
            'Private: The pool is privately owned and/or secluded.',
            'Rooftop Pool: The pool is located on a rooftop.',
            'Saltwater: The pool has a salt water system.',
            'Screen Enclosure: The pool has a screened enclosure.',
            'Solar Cover: The pool has a solar cover.',
            'Solar Heat: The pool has some form of solar heating.',
            'Sport: The pool has two shallow ends on opposite sides of the pool with a deeper center. ',
            'Tile: The pool is tiled. ',
            'Vinyl: The pool has a vinyl surface. ',
            'Waterfall: The pool has a waterfall.'
        ]
    },
    PatioAndPorchFeatures: {
        title: 'Patio And Porch Features Help',
        ruleHelp: ['Patio And Porch Features is required.'],
        generalHelpDesc: `A list of features or description of the patio or porch included in the sale/lease. <a href="https://ddwiki.reso.org/display/DDW17/PatioAndPorchFeatures+Field" target="_blank" rel="noopener noreferrer">RESo PatioAndPorchFeatures</a>.`,
        generalHelp: [
            'Arbor: The patio/porch has an arbor, a shelter of vines or branches, or of latticework, covered with climbing shrubs or vines.',
            'Awning(s): The property has awning(s).',
            'Covered: The property has a covered patio or porch.',
            'Deck: The property has a deck.',
            'Enclosed: The property has an enclosed patio or porch.',
            'Front Porch: The property has a front porch.',
            'Glass Enclosed: The property has a glass enclosed patio or porch.',
            'Mosquito System: The patio/porch has a mosquito repellant system, an application system designed to spray pesticides in a fine mist to kill mosquitoes and other insects outdoors. Misting systems include spray nozzles that are mounted around the perimeter of the dwelling in the lawn or landscaping, or on parts of the house or fence. The spray nozzles are connected by tubing to a supply of insecticide. Some misting systems may be turned on at preset intervals using a timer.',
            'Patio: The property has a patio.',
            'Porch: The property has a porch.',
            'Rear Porch: The property has a rear porch.',
            'Screened: The property has screened patio or porch.',
            'Side Porch: The property has a side porch.',
            'Terrace: The property has a terrace.',
            'Wrap Around: The property has wrap around patio or porch.'
        ]
    },
    CommunityFeatures: {
        title: 'Community Features Help',
        ruleHelp: ['Community Features is required.'],
        generalHelpDesc: `A list of features related to, or available within, the community <a href="https://ddwiki.reso.org/display/DDW17/CommunityFeatures+Field" target="_blank" rel="noopener noreferrer">RESo CommunityFeatures</a>.`,
        generalHelp: [
            'Airport/Runway: The community has an airport or runway.',
            'BBQ Pit/Grill: A heated structure or area for outdoor cooking/grilling.',
            'Bike Storage/Locker: There is a shared storage area/locker for bicycles.',
            'Business Center: A community business center.',
            'Car Share Available: The community has a car share program available.',
            'Clubhouse: The community has a clubhouse.',
            'Cluster Mailbox: The community uses cluster mailbox(es) for mail collection, instead of individual mailboxes per property.',
            "Common Grounds: Those portions of a building, land, and amenities owned (or managed) by a planned unit development (PUD) or condominium project's homeowners' association (or a cooperative project's cooperative corporation) that are used by all of the unit ",
            'owners, who share in the common expenses of their operation and maintenance. Common areas include swimming pools, tennis courts, and other recreational facilities, as well as common corridors of buildings, parking areas, means of ingress and egress, etc.',
            'Concierge: A service on site of the property that assists with tasks for residents living on the property.',
            'Conference/Meeting Room: A room serving an office complex and used primarily for staff meetings and departmental activities other than instructional activities.',
            'Controlled Access: Access to the community/property is limited to certain people, ususally residents. This may be done through keys, key cards, access codes, and community staff.',
            'Courtyard: There is a shared courtyard.',
            'Covered Parking: The community has shared covered parking spaces.',
            'Creative Office Space: The community has a shared creative office space.',
            'Curbs: The community streets have curbs.',
            'Designated Car-2-Go Space(s): The community has designated spaces for Car-2-Go cars, designed for residents to share.',
            'Dog Park/Play Area: A shared park for dogs to exercise and play off-leash in a controlled environment under the supervision of their owners.',
            'Electronic Payments: The community accepts electronic payment for bills and other fees.',
            'Equestrian Community: A place where Horses can exercise or riders congregate.',
            'Fishing: The community has places to go fishing.',
            'Fitness Center: The community has a fitness center.',
            'Game Room: The community has a shared, large room with no closet and space for games such as pool, ping pong, etc.',
            'Garage Parking: The community has a shared garage that is used for parking.',
            'Gated: The community is gated.',
            'General Aircraft Airport: The community has a shared airport for general aircraft.',
            'Golf Course: The property falls inside a community with a golf course for the residence.',
            'Google Fiber: The community has access to Google Fiber high-speed Internet wiring and services.',
            'Health Club Discount: The community comes with a discount to a health/fitness club.',
            'High Speed Internet Access: The community has access to a connection type of internet that transfers data via high-speed cable, satellite and wireless connections.',
            'Hot Tub Community: The community has a shared hot tub for residents.',
            'Housekeeping: The community has a shared housekeeping service available for residents.',
            'Kitchen Facilities: The community has a shared kitchen designated for cooking or the preparation of food.',
            'Lake: The community has a lake.',
            'Laundry Facility(s): The community has a shared laundry facility for residents.',
            'Laundry Service: The community has a laundry service available for residents.',
            'Library: The community has a shared area used to store and read novels/book/magazines.',
            'Lounge: The community has a shared area for sitting, waiting, and general lounging around.',
            'Maintenance On-Site: The community has on-site maintenance to repairs appliances and provide other maintenance services.',
            'Media Center/Movie Theatre: The community has shared television and video equipment designed to reproduce in the home the experience of being in a movie theater.',
            'Mini-Golf: The community has a shared miniature golf course.',
            'Nest Thermostat: The community provides a Nest Thermostat for residents.',
            'Night Security/Patrol: The community provides a night security/partrol service.',
            'On-Site Retail: The community has retail stores on site accessible by residents.',
            'Online Services: The community offers online services.',
            'Package Service: The community offers a package service where it will hold onto any packages delivered to residents.',
            'Park: The community has a park. ',
            "Pet Amenities: The community offers amenities for the resident's pets. Ex. Waste bags.",
            'Picnic Area: The community has a shared picnic area for residents.',
            'Planned Social Activities: The community has a schedule of regular, planned social activities for residents. Ex. Movie night, bingo.',
            'Playground: The community has a playground. ',
            'Pool: The community has a pool.',
            'Professional Fitness Center: The community has a professional fitness center, such as a privately-owned gym.',
            'Property Manager On-Site: The community has a property manager on-site for residents to contact.',
            'Putting Green: The community has a putting green for residents to practice their short game.',
            'Racquetball: The community has racquetball facilities.',
            'Recycling Area/Center: The community has a shared recycling area or center.',
            'Restaurant: The community has a restaurant.',
            'Rooftop Lounge: The community has a lounge on the rooftop of a shared building.',
            'Room Service: The community offers room service for residents.',
            'Sauna: The community has a shared sauna.',
            'Shopping Mall: The community has a shopping mall for the residents.',
            'Sidewalks: The community streets have sidewalks.',
            'Smart Car Charging: The community offers charging stations for electric/smart cars.',
            'Spa/Hot Tub: The community has a shared spa/hot tub.',
            'Sport Court(s)/Facility: The community has a shared sport court(s)/facility that can be used for various sports. Ex. Pickleball.',
            'Stable(s): The community has horse stables.',
            'Storage: The community has on-site storage for rsidents.',
            'Street Lights: The community streets have lighting.',
            'Suburban: The community is a suburban setting.',
            'Sundeck: The community has a shared sundeck for residents.',
            'Tanning Salon: The community has a shared tanning salon for residents.',
            'Tenant Access Cargo Elevator: The community has a shared tenant access cargo elevator for residents.',
            'Tennis Court(s): The community has a shared tennis court(s) for residents.',
            'Trash Pickup - Door to Door: The community has a shared program to pickup trash door to door for residents.',
            'Underground Utilities: The community provides underground utilities for residents.',
            'U-Verse: The community provides U-Verse Internet/Cable service for residents.',
            'Valet Parking: The community has a shared valet parking for residents.',
            'Walk/Bike/Hike/Jog Trail(s): The community has a walk/bike/hike/jog trail(s).'
        ]
    },
    LaundryLocation: {
        title: 'Laundry Location Help',
        ruleHelp: ['Laundry Location is required.'],
        generalHelpDesc: `The location in the dwelling where clothing can be washed and/or dried.`,
        generalHelp: [
            'Common Area: The washer and/or dryer are located in the common area of the property.',
            'In Basement: The washer and/or dryer are located in the basement of the property.',
            'In Bathroom: The washer and/or dryer are located in a bathroom of the property.',
            'In Carport: The washer and/or dryer are located in the carport on the property.',
            'In Garage: The washer and/or dryer are located in the garage of the property.',
            'In Hall: The washer and/or dryer are located in a hall of the property.',
            'In Kitchen: The washer and/or dryer are located in the kitchen of the property.',
            'In Unit: The washer and/or dryer are located in the unit of the property.',
            'Inside: The washer and/or dryer are located inside of the property.',
            'Laundry Closet: The washer and/or dryer are located in a laundry closet on the property.',
            'Laundry Room: The washer and/or dryer are located in a laundry room on the property.',
            'Lower Level: The washer and/or dryer are located on the lower level of the property.',
            'Main Level: The washer and/or dryer are located on the main level of the property.',
            'Multiple Locations: The washer and/or dryer are located in multiple locations on the property.',
            'Outside: The washer and/or dryer are located outside of the property.',
            'Upper Level: The washer and/or dryer are located on the upper level of the property.'
        ]
    },
    listAgentMLSID: {
        title: 'List Agent MLS ID Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `The Listing Agent's Board or Association of REALTORS. 
        <a href="https://ddwiki.reso.org/display/DDW17/ListAgentAOR+Field" target="_blank" rel="noopener noreferrer">RESo ListAgentAOR</a>.
        <br/><br/>
        North American 10 digit phone numbers should be in the format of ###-###-#### (separated by hyphens). Other conventions should use the common local standard. International numbers should be preceded by a plus symbol.
        <a href="https://ddwiki.reso.org/display/DDW17/ListAgentDirectPhone+Field" target="_blank" rel="noopener noreferrer">RESo ListAgentDirectPhone</a>.
        <br/><br/>
        The email address of the Listing Agent.  
        <a href="https://ddwiki.reso.org/display/DDW17/ListAgentEmail+Field" target="_blank" rel="noopener noreferrer">RESo ListAgentEmail</a>.
        <br/><br/>
        The full name of the listing agent. (First Middle Last) 
        <a href="https://ddwiki.reso.org/display/DDW17/ListAgentFullName+Field" target="_blank" rel="noopener noreferrer">RESo ListAgentFullName</a>.
        <br/><br/>
        A system unique identifier. Specifically, in aggregation systems, the ListAgentKey is the system unique identifier from the system that the record was retrieved. This may be identical to the related xxxId. This is a foreign key relating to the Member resource's MemberKey. This is the numeric only key and used as an alternative to the ListAgentKey field. 
        <a href="https://ddwiki.reso.org/display/DDW17/ListAgentKeyNumeric+Field" target="_blank" rel="noopener noreferrer">RESo ListAgentKeyNumeric</a>.
        <br/><br/>
        The local, well-known identifier for the member. This value may not be unique, specifically in the case of aggregation systems, this value should be the identifier from the original system. 
        <a href="https://ddwiki.reso.org/display/DDW17/ListAgentMlsId+Field" target="_blank" rel="noopener noreferrer">RESO ListAgentMlsId</a>.
        <br/><br/>
        The responsible Board or Association of REALTORS for this listing.
        <a href="https://ddwiki.reso.org/display/DDW17/ListAOR+Field" target="_blank" rel="noopener noreferrer">RESo ListAOR</a>.
        <br/><br/>
        A system unique identifier. Specifically, in aggregation systems, the Key is the system unique identifier from the system that the record was just retrieved. This may be identical to the related xxxId identifier, but the key is guaranteed unique for this record set. This is a foreign key relating to the Office resource's OfficeKey. This is the numeric only key and used as an alternative to the ListOfficeKey field.
        <a href="https://ddwiki.reso.org/display/DDW17/ListOfficeKeyNumeric+Field" target="_blank" rel="noopener noreferrer"> RESo ListOfficeKeyNumeric</a>.
        <br/><br/>
        The local, well-known identifier. This value may not be unique, specifically in the case of aggregation systems, this value should be the identifier from the original system.
        <a href="https://ddwiki.reso.org/display/DDW17/ListOfficeMlsId+Field" target="_blank" rel="noopener noreferrer">RESo ListOfficeMlsId</a>.
        <br/><br/>
        The legal name of the brokerage representing the seller.
        <a href="https://ddwiki.reso.org/display/DDW17/ListOfficeName+Field" target="_blank" rel="noopener noreferrer">RESo ListOfficeName</a>.
        <br/><br/>
        North American 10 digit phone numbers should be in the format of ###-###-#### (separated by hyphens). Other conventions should use the common local standard. International numbers should be preceded by a plus symbol.
        <a href="https://ddwiki.reso.org/display/DDW17/ListOfficePhone+Field" target="_blank" rel="noopener noreferrer">RESo ListOfficePhone</a>.
        <br/><br/>
        The extension of the given phone number (if applicable).
        <br/><br/>
        `
    },
    coListAgentMLSID: {
        title: 'Co List Agent MLS ID Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `North American 10 digit phone numbers should be in the format of ###-###-#### (separated by hyphens). Other conventions should use the common local standard. International numbers should be preceded by a plus symbol.
        <a href="https://ddwiki.reso.org/display/DDW17/CoListAgentDirectPhone+Field" target="_blank" rel="noopener noreferrer">RESo CoListAgentDirectPhone</a>.
        <br/><br/>
        The email address of the Co Listing Agent.
        <a href="https://ddwiki.reso.org/display/DDW17/CoListAgentEmail+Field" target="_blank" rel="noopener noreferrer">RESo CoListAgentEmail</a>.
        <br/><br/>
        The full name of the co-listing agent. (First Middle Last) 
        <a href="https://ddwiki.reso.org/display/DDW17/CoListAgentFullName+Field" target="_blank" rel="noopener noreferrer">RESo CoListAgentFullName</a>.
        <br/><br/>
        A system unique identifier. Specifically, in aggregation systems, the Key is the system unique identifier from the system that the record was just retrieved. This may be identical to the related xxxId identifier, but the key is guaranteed unique for this record set. This is a foreign key relating to the Member resource's MemberKey. This is the numeric only key and used as an alternative to the CoListAgentKey field.
        <a href="https://ddwiki.reso.org/display/DDW17/CoListAgentKeyNumeric+Field" target="_blank" rel="noopener noreferrer">RESo CoListAgentKeyNumeric</a>.
        <br/><br/>
        The local, well-known identifier. This value may not be unique, specifically in the case of aggregation systems, this value should be the identifier from the original system.
        <a href="https://ddwiki.reso.org/display/DDW17/CoListAgentMlsId+Field" target="_blank" rel="noopener noreferrer">RESo CoListAgentMlsId</a>.
        <br/><br/>
        A system unique identifier. Specifically, in aggregation systems, the Key is the system unique identifier from the system that the record was just retrieved. This may be identical to the related xxxId identifier, but the key is guaranteed unique for this record set. This is a foreign key relating to the Office resource's OfficeKey. This is the numeric only key and used as an alternative to the CoListOfficeKey field.
        <a href="https://ddwiki.reso.org/display/DDW17/CoListOfficeKeyNumeric+Field" target="_blank" rel="noopener noreferrer">RESo CoListOfficeKeyNumeric</a>.
        <br/><br/>
        The local, well-known identifier. This value may not be unique, specifically in the case of aggregation systems, this value should be the identifier from the original system.
        <a href="https://ddwiki.reso.org/display/DDW17/CoListOfficeMlsId+Field" target="_blank" rel="noopener noreferrer">RESo CoListOfficeMlsId</a>.
        <br/><br/>
        The legal name of the brokerage co-representing the seller.
        <a href="https://ddwiki.reso.org/display/DDW17/CoListOfficeName+Field" target="_blank" rel="noopener noreferrer">RESo CoListOfficeName</a>.
        <br/><br/>
        North American 10 digit phone numbers should be in the format of ###-###-#### (separated by hyphens). Other conventions should use the common local standard. International numbers should be preceded by a plus symbol.
        <a href="https://ddwiki.reso.org/display/DDW17/CoListOfficePhone+Field" target="_blank" rel="noopener noreferrer">RESo CoListOfficePhone</a>.
        <br/><br/>
        `
    },
    listingOverride: {
        title: 'Attribution Contact Override Help',
        ruleHelp: ['No rule help message defined.']
    },
    bathroomsFull: {
        title: '# Full Baths Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `The number of bathrooms consisting of a toilet, sink and bathing area, either tub and/or shower.`
    },
    bathroomsHalf: {
        title: '# Half Baths Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: 'The number of bathrooms consisting of only a toilet and sink.'
    },
    yearBuilt: {
        title: 'Year Built Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `The year when real property improvements were placed into service (home was built), or when construction of the improvements was completed. Remodels do not count unless it was torn down completely.`
    },
    living: {
        title: 'Living Help',
        ruleHelp: ['Living is required.'],
        generalHelpDesc: 'Describes the number of living rooms in the dwelling.'
    },
    livingArea: {
        title: 'Living Area Help',
        ruleHelp: ['Living Area is required.'],
        generalHelpDesc: `
        The total living area within the structure. Input SQFT.
        <a href="https://ddwiki.reso.org/display/DDW17/LivingArea+Field" target="_blank" rel="noopener noreferrer">RESO LivingArea</a>.`
    },
    livingAreaSource: {
        title: 'Living Area Source Help',
        ruleHelp: ['Living Area Source is required.'],
        generalHelpDesc: `
        The source of the measurements. This is a pick list of options showing the source of the measurement. If an option other than Public Records is selected, documentation should be added to the listing. 
        <a href="https://ddwiki.reso.org/display/DDW17/LivingAreaSource+Field" target="_blank" rel="noopener noreferrer">RESO LivingAreaSource</a>.
        `,
        generalHelp: [
            'Appraiser: An appraiser provided the measurement of the area.',
            'Builder: The builder provided the measurement of the area.',
            'Multiple Dwelling: The SQFT total entered into Living Area represents the combined area of multiple dwellings included as part of the listing.',
            'Estimated: The measurement of the area is an estimate.',
            'Owner: The owner provided the measurement of the area.',
            'Public Records: The measurement of the area was received from public records.'
        ]
    },
    dining: {
        title: '# Dining Help',
        ruleHelp: ['# Dining is required.'],
        generalHelpDesc: `
            The number of dining rooms in the dwelling.
        `
    },
    parkingTotal: {
        title: '# Parking Help',
        ruleHelp: ['# Parking is required.'],
        generalHelpDesc: `
            The total number of parking spaces, including Driveway and Carport(s), included in the sale.
            <a href="https://ddwiki.reso.org/display/DDW17/ParkingTotal+Field" target="_blank" rel="noopener noreferrer">RESO ParkingTotal</a>.
        `
    },
    parkingFeeFrom: {
        title: 'Parking Fee From Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: 'Parking Fee From'
    },
    parkingFeeTo: {
        title: 'Parking Fee To Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: 'Parking Fee To'
    },
    parkingFeeFrequency: {
        title: 'Parking Fee Frequency Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: 'Parking Fee Frequency'
    },
    parkingFeatures: {
        title: 'Parking Features Help',
        ruleHelp: ['Parking Features is required.'],
        generalHelpDesc: `
            A list of features or description of the parking included in the sale/lease.
            <a href="https://ddwiki.reso.org/display/DDW17/ParkingFeatures+Field" target="_blank" rel="noopener noreferrer">RESO ParkingFeatures</a>.
        `,
        generalHelp: [
            'Additional Parking: The property has additional parking.',
            'Aggregate: While aggregate is a type of concrete, it is different in application, maintenance, and durability. Aggregate, aka exposed aggregate concrete, is a mixture poured much in the same way as concrete, but which later has its top surface removed in order to expose the aggregate underneath.',
            'Alley Access: The property has alley access.',
            'Asphalt: The property has asphalt parking.',
            'Assigned: The property has assigned parking spaces.',
            'Attached: The property has attached parking.',
            'Attached Carport: The property has an attached carport.',
            'Basement: A basement garage is partially or mostly below grade, with its entrance level with the basement floor.',
            'Boat: The property has a space to park/store a boat.',
            'Carport: The property has a carport.',
            'Circular Driveway: The property has a circular driveway.',
            'Common: The property has common/shared parking.',
            'Community Structure: The property has a community parking structure.',
            'Concrete: The property has concrete paved parking.',
            'Converted Garage: The property has a converted garage.',
            'Covered: The property has covered parking.',
            'Deck: The property has deck for parking.',
            'Deeded: The property has deeded parking.',
            'Detached: The property has detached parking.',
            'Detached Carport: The property has a detached carport.',
            'Direct Access: The parking has direct access to the property or structure.',
            'Door-Multi: The property has more than one garage door.',
            'Door-Single: The property has one garage door.',
            'Drive Through: The property has drive through parking.',
            'Driveway: The property has a driveway.',
            'Electric Gate: The property has an electric gate.',
            'Electric Vehicle Charge Station(s): The property has one or more electric vehicle charging stations.',
            'Enclosed: The property has enclosed parking.',
            'Garage: The property has a garage.',
            'Garage Door Opener: The garage has an automatic garage door opener.',
            'Garage Faces Front: The property has a garage that faces the front of the property.',
            'Garage Faces Rear: The property has a garage that faces the rear of the property.',
            'Garage Faces Side: The property has a garage that faces the side of the property.',
            'Gated: The property has gated parking.',
            'Golf Cart Garage: The property has a golf cart garage.',
            'Gravel: The property has parking on gravel.',
            'Guest: The property has guest parking.',
            'Heated Garage: The property has a heated garage.',
            'Inside Entrance: The property has parking with an inside entrance.',
            'Kitchen Level: The property has parking at the kitchen level.',
            'Leased: The property has leased parking.',
            'Lighted: The property has lighted parking.',
            'Off Site: The property has off-site parking.',
            'Off Street: The property has off-street parking.',
            'Open: The property has open or unassigned parking.',
            'Outside: The property has outside parking which is not enclosed.',
            'Oversized: The property has parking for oversized vehicles.',
            'Parking Lot: The property has access to a parking lot.',
            'Parking Pad: The property has a parking pad.',
            'Parking Permit Required: Parking at the property or on the street requires a permit.',
            'Paved: The property has paved parking.',
            'Paver Block: The property has parking on paver blocks.',
            'Private: The property has private parking.',
            'Reserved: The property has reserved parking.',
            'RV Access/Parking: The property has access/parking for recreational vehicles.',
            'RV Carport: The property has a carport for recreational vehicles.',
            'RV Garage: The property has a garage for recreational vehicles.',
            'RV Gated: The property has gated parking for recreational vehicles.',
            'Secured: The property has secure parking.',
            'Shared Driveway: The property has a shared driveway.',
            'Side By Side: The property has side-by-side parking spaces.',
            'Storage: The property has storage in the parking area.',
            'Tandem: The property has tandem parking.',
            'Unassigned: The property has unassigned or open parking.',
            'Underground: The property has underground parking.',
            'Unpaved: The property has parking on an unpaved surface.',
            'Valet: The property has valet parking available.',
            'Varies by Unit: The parking varies from unit to unit.',
            'Workshop in Garage: The property has a workshop in the garage.'
        ]
    },
    complexName: {
        title: 'Complex Name Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: 'Complex Name'
    },
    unitsInComplex: {
        title: '# Units Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `Total number of units included in the income property, occupied or unoccupied. Residential Lease Only. 
        <a href="https://ddwiki.reso.org/display/DDW17/NumberOfUnitsTotal+Field" target="_blank" rel="noopener noreferrer">RESo NumberOfUnitsTotal</a>.
        `
    },
    floorPlanName: {
        title: 'Floor Plan Name/Number Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: 'Floor Plan Name Number'
    },
    smokingInside: {
        title: 'Smoking Inside YN Help',
        ruleHelp: ['Smoking Inside YN is required.'],
        generalHelpDesc: 'Smoking Inside YN'
    },
    moveInSpecialYN: {
        title: 'Move In Special YN Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: 'Move In Special YN'
    },
    moveInSpecialDescription: {
        title: 'Move In Special Description Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: 'Move In Special Description'
    },
    garageSpaces: {
        title: '# Garage Spaces Help',
        ruleHelp: ['Garage Spaces is required.'],
        generalHelpDesc: 'The number of spaces in the garage(s).'
    },
    directionFaces: {
        title: 'Direction Faces Help',
        ruleHelp: ['Direction Faces is required.'],
        generalHelpDesc: `The compass direction that the main entrance to the building faces. For example, North, South, East, West, South-West, etc. 
        <a href="https://ddwiki.reso.org/display/DDW17/DirectionFaces+Field" target="_blank" rel="noopener noreferrer">RESO DirectionFaces</a>.
        `
    },
    lotSizeAcres: {
        title: 'Acres Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `The total Acres of the lot. Acreage will be auto-calculated from SQFT total in Living Area, if filling from tax records. 
        <a href="https://ddwiki.reso.org/display/DDW17/LotSizeAcres+Field" target="_blank" rel="noopener noreferrer">RESO LotSizeAcres</a>.
        `
    },
    lotDimensions: {
        title: 'Lot Size Dimensions Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `The dimensions of the lot represented as frontage and depth (i.e. 250 x 180).
        <a href="https://ddwiki.reso.org/display/DDW17/LotSizeDimensions+Field" target="_blank" rel="noopener noreferrer">RESO LotSizeDimensions</a>.
        `
    },
    lotFeatures: {
        title: 'Lot Features Help',
        ruleHelp: ['Lot Features is required.'],
        generalHelpDesc: `
            A list of features or description of the lot included in the sale/lease.
            <a href="https://ddwiki.reso.org/display/DDW17/LotFeatures+Field" target="_blank" rel="noopener noreferrer">RESO LotFeatures</a>.
        `,
        generalHelp: [
            'Agricultural: The lot has agricultural features.',
            'Alley Access: The lot has alley access.',
            'Back to Park/Greenbelt: The lot backs to a section of a park/Greenbelt.',
            'Back Yard: The lot has a back yard.',
            'Bluff: The lot is on or near a bluff.',
            'City Lot: The lot is in a city/urban setting.',
            'Cleared: The lot has been cleared.',
            'Close to Clubhouse: The lot is located close to the community clubhouse.',
            'Corner Lot: The lot is located on the corner of an intersection.',
            'Cul-de-sac: The lot is located on a street that is closed on one end in a circular shape.',
            'Curbs: The lot has curbs.',
            'Farm: The lot is, or has characteristics of, a farm.',
            'Few Trees: The lot has a few trees.',
            'Flag Lot: A flag lot has a long driveway leading to the property, resembling a pole and flag.',
            'Front Yard: The lot has a front yard.',
            'Garden: The lot has a garden.',
            "Gentle Sloping: The lot's slope is gentle.",
            'Interior Lot: An interior lot faces the street on only one side.',
            'Irregular Lot: The lot is not a rectangle.',
            'Landscaped: The lot has been fully or partially landscaped.',
            'Level: The lot is level/flat.',
            "Native Plants: The lot's landscaping includes native plants.",
            'Near Golf Course: The lot is near a golf course.',
            'Near Public Transit: The lot is near public transportation.',
            'Open Lot: The lot is open.',
            'Orchard(s): The lot includes one or more orchards.',
            'Pie Shaped Lot: The lot is pie or triangle shaped, typically narrow at the front and wide at the back.',
            'Private: The lot is private or features privacy from adjacent areas.',
            'Private Maintained Road: The lot has a road that is privately maintained.',
            'Public Maintained Road: The lot contains a road maintained by the city.',
            'Road Maintenance Agreement: The lot includes an agreement for maintaining the road.',
            'Rock Outcropping: The lot has rock features or barriers.',
            'Rolling Slope: The slope of the property varies in a rolling fashion.',
            'Sloped Down: The lot is sloped down from the perspective of looking from the street.',
            'Sloped Up: The lot is sloped up from the perspective of looking from the street.',
            'Split Possible: The lot could potentially be split into two or more parcels.',
            'Sprinkler - Automatic: The lot comes with an automatic sprinkler system.',
            'Sprinkler - Back Yard: The lot has a sprinkler system in the back yard.',
            'Sprinkler - Drip Only/Bubblers: The lot has a subsurface irrigation system that minimizes water losses.',
            'Sprinkler - In Front: The lot has sprinklers in the front.',
            'Sprinkler - In-ground: The lot has underground sprinklers.',
            'Sprinkler - Manual: The lot has a manual sprinkler system.',
            'Sprinkler - Partial: The lot has a sprinkler system that only partially covers the lot.',
            "Sprinkler - Rain Sensor: The lot's sprinkler system contains a rain sensor to prevent watering during rain.",
            'Sprinkler - Side Yard: The lot has sprinklers in the side yard.',
            'Steep Slope: The lot is sloped steeply.',
            'Subdivided: The lot has been subdivided into two or more parcels.',
            'Trees - Heavy: The lot has a heavily wooded area.',
            'Trees - Large (Over 40 Ft): The lot has large trees over 40 feet tall.',
            'Trees - Many: The lot has many trees.',
            'Trees - Medium (20 Ft - 40 Ft): The lot has medium-sized trees (20 to 40 feet tall).',
            'Trees - Moderate: The lot has a moderate amount of trees.',
            'Trees - Small (Under 20 Ft): The lot has small trees under 20 feet tall.',
            'Trees - Sparse: The lot has a sparse amount of trees.',
            'Views: The lot has views.',
            'Waterfall: The lot has a waterfall.',
            'Wetlands: The lot is near or within wetlands.',
            'Xeriscape: The lot has creative landscaping for water and energy efficiency.',
            'Zero Lot Line: The structure comes up to or near the property line.'
        ]
    },
    waterfrontFeatures: {
        title: 'Waterfront Features Help',
        ruleHelp: ['Waterfront Features is required.'],
        generalHelpDesc: `
           Features of the waterfront on which the property is located. The waterfront feature(s) must be on/adjacent to the property, not just near it. If any options are selected, Distance to Water Access must be "Less Than 1 Mile.
        `,
        generalHelp: [
            'Canal Front: The property is located on or adjacent to the canal.',
            'Creek: The property is on or adjacent to a creek.',
            'Dry/Seasonal: An arrangement of stones and rocks that imitates the look of a stream bed although no water is present.',
            'Lake Front: The property is on or adjacent to the lake front.',
            'Lake Privileges: The property includes rights to access the lake.',
            'Pond: The property is on or adjacent to a pond.',
            'River Front: The property is located on or adjacent to the river front.',
            'Stream: The property is on or adjacent to a stream.',
            'Waterfront: The property is located on or adjacent to the waterfront.'
        ]
    },
    distanceToWaterAccess: {
        title: 'Distance To Water Access Help',
        ruleHelp: ['Distance To Water Access is required.'],
        generalHelpDesc: `
           The distance the property is from access to a body of water, through the neighborhood.
        `,
        generalHelp: [
            'Must select "Less Than 1 Mile" if any option is selected from Waterfront Features, since those features are tied to properties that are on or adjacent to those features.'
        ]
    },
    waterBodyName: {
        title: 'Water Body Name Help',
        ruleHelp: ['Water Body Name is required.'],
        generalHelpDesc: `
           The name, if known, of the body of water on which the property is located. The property must be adjacent to or located on the Body of Water, not just near it.
        `
    },
    propertyCondition: {
        title: 'Property Condition Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
            The condition of the property and any structures included in the sale.
            <a href="https://ddwiki.reso.org/display/DDW17/PropertyCondition+Field" target="_blank" rel="noopener noreferrer">RESO PropertyCondition</a>.
        `,
        generalHelp: [
            'Historic Design: A building that is officially recognized for its historic design and age relevance.',
            'New Construction: The property has not been lived in; the deed has not been changed from the builder.',
            'Resale/Re-Lease: The sale of a property previously bought/owned or leased.',
            'Tear Down: The value of the property is in the land, and the dwelling is intended to be torn down.',
            'To Be Built: The property has yet to begin construction.',
            'Under Construction: The property is still under construction and building has not been completed.',
            'Updated/Remodeled: The property has been remodeled or updated in some fashion, which may include painting, repairing, and replacing fixtures and equipment.'
        ]
    },
    constructionMaterials: {
        title: 'Construction Materials Help',
        ruleHelp: ['Construction Materials is required.'],
        generalHelpDesc: `
            A list of the materials that were used in the construction of the property.
            <a href="https://ddwiki.reso.org/display/DDW17/ConstructionMaterials+Field" target="_blank" rel="noopener noreferrer">RESO ConstructionMaterials</a>.
        `,
        generalHelp: [
            'Adobe: The structure was made wholly or partly with adobe.',
            'Asbestos: The structure was made wholly or partly with asbestos.',
            'Asphalt: The structure was made wholly or partly with asphalt.',
            'Attic/Crawl Hatchway(s) Insulated: The attic or crawlspace hatch is insulated to reduce heat loss in winter and heat gain in summer.',
            'Block: The structure was made wholly or partly with block.',
            'Blown-In Insulation: The structure uses blown-in insulation made of fiberglass, rock wool, or cellulose, installed using pneumatic equipment.',
            'Brick: The structure was made wholly or partly with brick.',
            'Brick Veneer: The structure was made wholly or partly with brick veneer, with no structural role.',
            'Cedar: The structure was made wholly or partly with cedar.',
            'Clapboard: The structure was made wholly or partly with clapboard siding.',
            'Concrete: The structure was made wholly or partly with concrete.',
            'Frame: The structure was made wholly or partly with a wooden frame.',
            'Glass: The structure was made wholly or partly with glass.',
            'HardiPlank Type: The structure was made wholly or partly with HardiPlank, a fiber-cement siding.',
            'ICAT Recessed Lighting: The structure uses ICAT-rated recessed light fixtures that are insulation-contact and airtight.',
            'ICFs (Insulated Concrete Forms): The structure was made wholly or partly with insulated concrete forms (ICFs).',
            'Log: The structure was made wholly or partly with logs.',
            'Low VOC Insulation: The structure uses insulation certified as having low volatile organic compound (VOC) content.',
            'Masonite: The structure was made wholly or partly with Masonite.',
            'Masonry - Partial: The exterior has one, two, or three walls bonded with brick, concrete, or stone.',
            'Masonry - All Sides: All exterior walls are bonded with brick, concrete, or stone.',
            'Natural Building: The structure was made wholly or partly with natural materials such as straw, earth, or rock, emphasizing sustainability.',
            'Plaster: The structure was made wholly or partly with plaster.',
            'Radiant Barrier: The structure includes a radiant barrier for energy efficiency.',
            'Rammed Earth: The structure was made wholly or partly with rammed earth.',
            'Recycled/Bio-Based Insulation: The insulation is made from recycled or bio-based materials like paper, soy, or denim.',
            'Siding-Aluminum: The structure was made wholly or partly with aluminum siding.',
            'Siding-Board & Batten: The structure was made wholly or partly with board and batten siding.',
            'Siding-Cement: The structure was made wholly or partly with cement siding.',
            'Siding-Metal: The structure was made wholly or partly with metal siding (excluding aluminum).',
            'Siding-Redwood: The structure was made wholly or partly with redwood siding.',
            'Siding-Shake: The structure was made wholly or partly with shake siding.',
            'Siding-Vertical: The structure was made wholly or partly with vertical siding.',
            'Siding-Vinyl: The structure was made wholly or partly with vinyl siding.',
            'Siding-Wood: The structure was made wholly or partly with wood siding.',
            'Spray Foam Insulation: The structure was made wholly or partly with spray foam insulation.',
            'Stone: The structure was made wholly or partly with stone, such as marble, granite, limestone, sandstone, or slate.',
            'Stone Veneer: The structure was made wholly or partly with stone veneer, replicating the look of natural stone.',
            'Straw: The structure was made wholly or partly with straw, often used in natural or sustainable building projects.',
            'Stucco: The structure was made wholly or partly with stucco, a mixture of sand and cement used on exterior or interior walls.',
            'Synthetic Stucco: The structure was made wholly or partly with synthetic stucco.'
        ]
    },
    foundationDetails: {
        title: 'Foundation Details Help',
        ruleHelp: ['Foundation Details is required.'],
        generalHelpDesc: `
            A list of the type(s) of foundation on which the property sits.
            <a href="https://ddwiki.reso.org/display/DDW17/FoundationDetails+Field" target="_blank" rel="noopener noreferrer">RESO FoundationDetails</a>.
        `,
        generalHelp: [
            'Block: The foundation of the property is made wholly or partially of block.',
            'Brick/Mortar: The foundation of the property is made wholly or partially of brick and mortar.',
            'Combination: The foundation of the property is made of a combination of materials.',
            'Concrete Perimeter: The foundation of the property has a concrete perimeter.',
            'Permanent: The foundation is permanent and not temporary or movable.',
            'Pillar/Post/Pier: The foundation of the property is made wholly or partially of pillars, posts, or piers.',
            'Raised: The foundation of the property is raised.',
            'Slab: The foundation of the property is made wholly or partially of a concrete slab.'
        ]
    },
    roof: {
        title: 'Roof Help',
        ruleHelp: ['Roof is required.'],
        generalHelpDesc: `
            A list describing the type or style of roof.
            <a href="https://ddwiki.reso.org/display/DDW17/Roof+Field" target="_blank" rel="noopener noreferrer">RESO Roof</a>.
        `,
        generalHelp: [
            'Aluminum: The roof is made wholly or partially of aluminum.',
            'Asbestos Shingle: The roof is made wholly or partially of asbestos shingles.',
            'Asphalt: The roof is made wholly or partially of asphalt.',
            'Bahama: The roof is a Bahama roof.',
            'Barrel: The roof is a Barrel roof.',
            'Bituthene: The roof is made wholly or partially of Bituthene.',
            'Built-Up: The roof is made wholly or partially of built-up material.',
            'Composition: The roof is made wholly or partially of composition material.',
            'Concrete: The roof is made wholly or partially of concrete.',
            'Copper: The roof is made wholly or partially of copper.',
            'Elastomeric: The roof is made wholly or partially of elastomeric material.',
            'Fiberglass: The roof is made wholly or partially of fiberglass.',
            'Flat Tile: The roof is made wholly or partially of flat tile.',
            'Foam: The roof is made wholly or partially of foam.',
            'Green Roof: The roof is wholly or partially a green roof.',
            'Mansard: The roof is a Mansard roof, with four sloping sides becoming steeper halfway down.',
            'Membrane: The roof is made of membrane material, commonly used on flat or nearly flat roofs.',
            'Metal: The roof is made wholly or partially of metal.',
            'Mixed: The roof is made of mixed materials.',
            'Rolled/Hot Mop: The roof is made wholly or partially of rolled or hot mop material.',
            'Rubber: The roof is made wholly or partially of rubber.',
            'Shake: The roof is made wholly or partially of shake.',
            'Shingle: The roof is made wholly or partially of shingle.',
            'Slate: The roof is made wholly or partially of slate.',
            'Spanish Tile: The roof is made wholly or partially of Spanish tile.',
            'Stone: The roof is made wholly or partially of stone.',
            'Synthetic: The roof is made wholly or partially of synthetic materials.',
            'Tar/Gravel: The roof is made wholly or partially of tar and gravel.',
            'Tile: The roof is made wholly or partially of tile.',
            'Wood: The roof is made wholly or partially of wood.'
        ]
    },
    view: {
        title: 'View Help',
        ruleHelp: ['View is required.'],
        generalHelpDesc: `
            A view as seen from the listed property. 
            <a href="https://ddwiki.reso.org/display/DDW17/View+Lookups" target="_blank" rel="noopener noreferrer">RESO View</a>.
        `,
        generalHelp: [
            'Bridge(s): The property has a bridge(s) view.',
            'Canal: The property has a canal view.',
            'Canyon: The property has a canyon view.',
            'City: The property has a city view.',
            'City Lights: The property has a view of the city lights.',
            'Creek/Stream: The property has a creek/stream view.',
            'Downtown: The property has a downtown view.',
            'Garden: The property has a garden view.',
            'Golf Course: The property has a view of the golf course.',
            'Hill Country: The property has a view of the hills/hill country.',
            'Lake: The property has a lake view.',
            'Marina: The property has a marina view.',
            'Neighborhood: The property has a view of the neighborhood.',
            'Orchard: The property has a view of the orchard(s).',
            'Panoramic: The property has a panoramic view.',
            'Park/Greenbelt: The property has a park/greenbelt view.',
            'Pasture: The property has a view of the pasture.',
            'Pond: The property has a view of a pond.',
            'Pool: The property has a view of the pool.',
            'River: The property has a river view.',
            'Rural: The property has a rural view.',
            'Skyline: The property has a view of the skyline.',
            'Trees/Woods: The property has a view of the trees or woods.',
            'Vineyard: The property has a view of the vineyard(s).',
            'Water: The property has a water view.'
        ]
    },
    flooring: {
        title: 'Flooring Help',
        ruleHelp: ['Flooring is required.'],
        generalHelpDesc: `
            A list of the type(s) of flooring found within the property. 
            <a href="https://ddwiki.reso.org/display/DDW17/Flooring+Field" target="_blank" rel="noopener noreferrer"> RESo Flooring</a>.
        `
    },
    restrictions: {
        title: 'Restrictions Help',
        ruleHelp: ['Restrictions is required.']
        // generalHelpDesc: `
        //     A list of the type(s) of flooring found within the property.
        //     <a href="https://ddwiki.reso.org/display/DDW17/Flooring+Field" target="_blank" rel="noopener noreferrer"> RESo Flooring</a>.
        // `
    },
    builderName: {
        title: 'Builder Name Help',
        ruleHelp: ['Builder Name is required.'],
        generalHelpDesc: `
            Name of the builder of the property or builder's tract.
            <a href="https://ddwiki.reso.org/display/DDW17/BuilderName+Field" target="_blank" rel="noopener noreferrer">RESO BuilderName</a>.
        `
    },
    unitStyle: {
        title: 'Unit Style Help',
        ruleHelp: ['Unit Style is required.'],
        generalHelpDesc: `
            Description of the individual unit type/style available to possess.
        `,
        generalHelp: [
            '1st Floor Entry: The entrance to the unit is on the 1st floor.',
            '2nd Floor Entry: The entrance to the unit is on the 2nd floor.',
            '3rd+ Floor Entry: The entrance to the unit is on the 3rd floor.',
            'Low Rise (1-3 Stories): The unit is part of a low rise (1-3 stories) complex.',
            'Mid Rise (4-7 Stories): The unit is part of a mid-rise (4-7 stories) complex.',
            'High Rise (8-13 Stories): The unit is part of a high rise (8-13 stories) complex.',
            'Tower (14+ Stories): The unit is part of a tower (14+ stories) complex.',
            'Single-level Floor Plan: The unit has a floor plan of a single level.',
            "Elevator: The unit's complex has an elevator.",
            'End Unit: Last dwelling preceded by other properties.',
            'Entry Steps: Walkway that leads to the front of the house or dwelling.',
            'Middle Unit: It is preceded by the initial unit and followed by the final unit.',
            'Loft: Unpartitioned living space or space built just below the roof, above a larger room.',
            'Multi-level Floor Plan: The unit has a floor plan of multiple levels.',
            'Neighbor Above: An occupant above the property or dwelling.',
            'Neighbor Below: An occupant below the property or dwelling.',
            'No Adjoining Neighbor: No occupant surrounds the property or dwelling.',
            'Stilt Home: Houses raised on piles over the surface of the soil or water to protect against flooding.'
        ]
    },
    greenEnergyEfficient: {
        title: 'Green Energy Efficient Help',
        ruleHelp: ['Green Energy Efficient is required.'],
        generalHelpDesc: `
            Pick list of general green attributes such as energy efficient doors, or appliances without naming specific elements with ratings that may wane over time.
            <a href="https://ddwiki.reso.org/display/DDW17/GreenEnergyEfficient+Field" target="_blank" rel="noopener noreferrer">RESO GreenEnergyEfficient</a>.
        `,
        generalHelp: [
            'Appliances: For marketing, the property has appliances with a green/efficient rating or quality.',
            'Construction: For marketing, the property has construction with a green/efficient rating or quality.',
            'Doors: For marketing, the property has doors with a green/efficient rating or quality.',
            'Exposure/Shade: For marketing, the property has exposure/shade with a green/efficient rating or quality.',
            'Healthy Living Features: Features that contribute to better indoor air quality, accessibility, and health.',
            'Incentives: For marketing, the property has incentives with a green/efficiency focus.',
            'HVAC: For marketing, the property has a heating, ventilation, and air conditioning system with a green/efficient rating or quality.',
            'Insulation: For marketing, the property has insulation with a green/efficient rating or quality.',
            'Lighting: For marketing, the property has lighting with a green/efficient rating or quality.',
            'Materials and Construction: Features that contribute to material resource efficiency and energy efficiency in construction and operations.',
            'Roof: For marketing, the property has a roof with a green/efficient rating or quality.',
            'Solar Panels: The property has solar panels on the roof, walls, or lot.',
            'Sustainability: Features that contribute to long-term benefits to the community.',
            'Thermostat: For marketing, the property has thermostats with a green/efficient rating or quality.',
            'Water Heater: For marketing, the property has a water heater with a green/efficient rating or quality.',
            'Wind Turbines: Electrical power supplied by an onsite wind turbine.',
            'Windows: For marketing, the property has windows with a green/efficient rating or quality.'
        ]
    },
    greenSustainability: {
        title: 'Green Sustainability Help',
        ruleHelp: ['Green Sustainability is required.'],
        generalHelpDesc: `
            Pick list of sustainable elements used in the construction of the structure without naming specific elements with ratings that may wane over time.
            <a href="https://ddwiki.reso.org/display/DDW17/GreenSustainability+Field" target="_blank" rel="noopener noreferrer">RESO GreenSustainability</a>.
        `,
        generalHelp: [
            'Conserving Methods: Construction is planned to require fewer materials while maintaining structural integrity, potentially including advanced wall framing or indigenous construction methods such as straw bale, sod, or clay, based on local climate, materials, and practices.',
            'Onsite Recycling Center: Property includes built-in storage space and/or containers for temporary storage of recyclable materials and/or compost collection.',
            'Recyclable Materials: Structure includes products with significant postconsumer recycled content (typically 25% or more). Examples include masonry, paving stones with fly ash, aluminum gutters, decking, drywall fibers, insulation, vinyl plastics, countertops, and cabinets. More details can be found in Home Innovation Research Labs or LEED credit tables.',
            'Recycled Materials: Structure includes products with significant postconsumer recycled content (typically 25% or more). Examples include masonry, paving stones with fly ash, aluminum gutters, decking, drywall fibers, insulation, vinyl plastics, countertops, and cabinets. More details can be found in Home Innovation Research Labs or LEED credit tables.',
            'Regionally-Sourced Materials: Building materials were manufactured, extracted, harvested, or recovered within 500 miles of the building.',
            'Renewable Materials: Structure includes materials that are naturally occurring, abundant, and/or fast-growing. This may include certified flooring and wood products or bio-based materials such as paper, straw, soy, natural fibers, and crops.',
            'Salvaged Materials: Structure incorporates materials diverted from landfills or repurposed for new use. Examples include bricks, timbers, roofing, flooring, walls, cabinets, and doors.'
        ]
    },
    greenEnergyVerification: {
        title: 'Green Building Verification Type Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
            <iframe width="100%" height="100%" src="https://www.youtube.com/embed/WvU5Nc8_SJ8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            The name of the verification or certification awarded to a new or pre-existing residential or commercial structure. For example: LEED for Homes, Energy Star, HERS Index Score. etc. In cases where more than one certification have been awarded, leverage multiple iterations of the green verification fields via the repeating element method.
        `,
        generalHelp: [
            "Austin Energy's Green Building: Rates new constructions and major remodels 1- to 5-Stars based on community resource and site sustainability, design, materials and construction efficiency, energy and water conservation, high-performance systems, indoor environmental quality, and innovation. Assistance available from the City of Austin Energy for improvements.",
            'LEED For Homes: Certification by the USGBC for new single-family homes based on sustainable sites, community connectivity, energy and water efficiency, construction material efficiency, indoor environmental quality, education, and innovation. Certification levels: Certified, Silver, Gold, Platinum.',
            "ENERGY STAR Certified Homes: Set of construction practices and technologies to upgrade a home's energy efficiency beyond minimum code requirements. Homes must be verified by a third-party organization.",
            'Home Performance with ENERGY STAR: Offers comprehensive home assessments and improvements to address high energy bills and comfort problems. Managed by local sponsors and follows specific guidelines.',
            "HERS Index Score: Measures a home's energy performance relative to a reference home. Lower scores indicate higher energy efficiency. Calculated by certified RESNET home energy raters.",
            "Building America: DOE's program aimed at achieving cost-neutral, net zero homes by 2030 through improved building performance.",
            'Certified Passive House: Super-insulated new homes meeting certification requirements for minimal or no heating and cooling systems.',
            'PHIUS+: Certification for super-insulated homes with minimal or no heating and cooling systems.',
            'EnerPHit: Certification for super-insulated existing homes remodeled to meet requirements for minimal or no heating and cooling systems.',
            "Environments for Living: Provides certification and performance testing for energy efficient construction. Guarantees energy usage for heating and cooling and comfort. Optional 'Certified Green' verification for indoor environmental quality and appliance efficiency.",
            'Home Energy Upgrade Certificate of Energy Efficiency Improvements: BPI Standard requirements for describing improvements made to an existing home through a home energy upgrade.',
            'Home Energy Upgrade Certificate of Energy Efficiency Performance: BPI Standard requirements for describing improvements and providing measures of performance such as HERS rating or Home Energy Score.',
            "Home Energy Score: A national system rating a home's energy efficiency on a 10-point scale, with 10 being most efficient. Uses standard calculation methods and is provided by Qualified Assessors.",
            'Indoor airPLUS: Optional construction practices to improve indoor air quality, available to homes meeting ENERGY STAR Certified Homes certification.',
            'Living Building Challenge: Certification for homes that produce as much or more energy than they use, with super-insulated designs meeting minimal or no heating and cooling system requirements.',
            'NGBS New Construction: Certification by Home Innovation Research Labs to the ICC-700 National Green Building Standard(tm) for new construction, remodel projects, and land development. Certification levels: bronze, silver, gold, emerald.',
            'NGBS Small Projects Remodel: Certification for small remodel projects like kitchens or bathrooms. Does not have multiple certification levels.',
            'NGBS Whole-Home Remodel: Certification for whole-home remodels with levels: bronze, silver, gold, emerald.',
            'WaterSense Certified Home: Optional construction practices to ensure reduced water usage while maintaining comfort and convenience. Also applies to specific plumbing fixtures.',
            "Zero Energy Ready Home: Set of construction practices and technologies to ensure homes are so energy efficient that most annual energy consumption can be offset with renewable energy. Guidelines outlined in the 'DOE Zero Energy Ready Home National Program Requirements.'"
        ]
    },
    verificationMetric: {
        title: 'Green Verification Metric Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
           A final score indicating the performance of energy efficiency design and measures in the home as tested by a third-party rater. Points achieved to earn a certification in the Green Verification Rating field do not apply to this field. HERS Index is most common with new homes and runs with a lower number being more efficient. If you have a score for a Green Building Verification Type, use this field. Ex. If HERS Index Score = 63 (put 63 in this field)
        `
    },
    verificationStatus: {
        title: 'Green Verification Status Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
           Many verification programs include a multi-step process that may begin with plans and specs, involve testing and/or submission of building specifications along the way and include a final verification step. When ratings are involved it is not uncommon for the final rating to be either higher or lower than the target preliminary rating. Sometimes the final approval is not available until after sale and occupancy. Status indicates what the target was at the time of listing and may be updated when verification is complete. To limit liability concerns this field reflects information that was available at the time of listing or updated later and should be confirmed by the buyer.
        `
    },
    verificationRating: {
        title: 'Green Verification Type Rating Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
           Many verifications or certifications have a rating system that provides an indication of the structure's level of energy efficiency. When expressed in a numeric value, please use the Green Verification Metric field. Verifications and Certifications can also be a name, such as Gold or Silver, which is the purpose of this field.Ex. For an Austin Energy Green Built home with a 5-Star rating, put "5-Star" in this field.
        `
    },
    verificationYear: {
        title: 'Green Verification Year Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
          The year the certification or verification was awarded.
        `
    },
    associationYN: {
        title: 'HOA YN Help',
        ruleHelp: ['Association YN is required.'],
        generalHelpDesc: `
          Is there a Home Owners Association (HOA)?
           <a href="https://ddwiki.reso.org/display/DDW17/AssociationYN+Field" target="_blank" rel="noopener noreferrer">RESO AssociationYN</a>.
        `
    },
    applicationFee: {
        title: 'Application Fee Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
          A charge by a lender/owner/landlord to a potential tenant for the time and effort required to accept and process the application for leasing a property.
        `
    },
    applicationFeePerPerson: {
        title: 'Per Person YN Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
          Is there an Application Fee per person/applicant?
        `
    },
    applicationFeePayableTo: {
        title: 'App Fee Payable To Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
          Describes the party that the Application Fee is payable to.
        `
    },
    managedBy: {
        title: 'Managed By Help',
        ruleHelp: ['Managed By is required.'],
        generalHelpDesc: `
          Describes the management type, either Owner or Property Manager.
        `
    },
    securityDeposit: {
        title: 'Security Deposit Help',
        ruleHelp: ['Security Deposit is required.'],
        generalHelpDesc: `
          A payment required by a landlord, to be held during the term of a lease to offset damages incurred due to actions of the tenant. Such damages may include physical damage to the property, theft of property, failure to pay back rent and breaking the lease. Forfeiture of the deposit does not absolve the tenant of further financial liability.
        `
    },
    securityDepositPayableTo: {
        title: 'Deposit PayableTo Help',
        ruleHelp: ['Deposit PayableTo is required.'],
        generalHelpDesc: `
          Deposit PayableTo is required.
        `
    },
    administrationFee: {
        title: 'Administration Fee Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
            The dollar($) amount that is paid towards an Administration Fee.
        `
    },
    administrationFeePayableTo: {
        title: 'Admin Fee Payble To Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
            The person/entity that the Administration Fee is paid towards.
        `
    },
    firstMonthRentPayableTo: {
        title: 'First Month Rent Payable To Help',
        ruleHelp: ['First Month Rent Payable To is required.'],
        generalHelpDesc: `
            The person/entity the first month rent payment is to.
        `
    },
    shortTermPremium: {
        title: 'Short Term Premium YN Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
            Allows a resident to have flexibility in the way of getting out of the lease contract without any lease break penalties. Ex. A simple month to month premium that you tack on at the initiation of the lease term.
        `
    },
    shortTermPremiumAmount: {
        title: 'Short Term Premium Amount Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
            The amount charged that allows a resident to have flexibility in the way of getting out of the lease contract without any lease break penalties. Ex. A simple month to month premium that you tack on at the initiation of the lease term.
        `
    },
    onSiteCompliance: {
        title: 'On Site Compliance YN Help',
        ruleHelp: ['On Site Compliance YN is required.'],
        generalHelpDesc: `
            Inspections or audits will be done periodically.
        `
    },
    renterInsuranceRequired: {
        title: 'Renters Insurance Required YN Help',
        ruleHelp: ['Renters Insurance Required YN is required.'],
        generalHelpDesc: `
            Is some form of renter's insurance required for a tenant?
        `
    },
    petsAllowed: {
        title: 'Pets Allowed Help',
        ruleHelp: ['Pets Allowed is required.'],
        generalHelpDesc: `
           Are pets allowed at the property being leased? A list of yes, no and more detailed restrictions/allowances.
           <a href="https://ddwiki.reso.org/display/DDW17/PetsAllowed+Field" target="_blank" rel="noopener noreferrer">RESO PetsAllowed</a>.
        `,
        generalHelp: [
            'Cats OK: Cats are allowed.',
            'Dogs OK: Dogs are allowed.',
            'Small (Less than 20 lbs): Pets that weigh less than 20 lbs are allowed.',
            'Medium (Less than 35 lbs): Pets that weigh less than 35 lbs are allowed.',
            'Large (Less than 50 lbs): Pets that weigh less than 50 lbs are allowed.',
            'No Weight Limit: There is no weight limit on allowed pets.',
            'Number Limit: There is a limit on the number of pets allowed.',
            'Size Limit: There are size restrictions on allowed pets.',
            'Breed Restrictions: There are breed restrictions on allowed pets.',
            'No Breed Restrictions: There are no breed restrictions on allowed pets.',
            'All: All types of pets are allowed.',
            'No: No pets are allowed.',
            'Call: Call to inquire about pet restrictions.',
            'Negotiable: Pets allowed is negotiable.'
        ]
    },
    petDeposit: {
        title: 'Pet Deposit Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
            The dollar($) amount for a deposit required for any pets on the premises.
        `
    },
    maxNumberOfPets: {
        title: 'Max # Pets Help',
        ruleHelp: ['Max Numof Pets is required.'],
        generalHelpDesc: `
            The maximum number of pets allowed.
        `
    },
    petDepositPerPet: {
        title: 'Per Pet YN Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
            Does the amount entered in the Pet Deposit field apply to each pet that will live at the premises?
        `
    },
    monthlyPetRent: {
        title: 'Monthly Pet Rent Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
            A monthly, recurring dollar($) amount that is paid for a pet living on the premises.
        `
    },
    monthlyPetRentPerPet: {
        title: 'Monthly Pet Rent Per Pet YN Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
            Does the monthly, recurring Monthly Pet Rent amount apply per pet living on the premises?
        `
    },
    additionalPetFee: {
        title: 'Additional Pet Fee Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
           The dollar($) amount for an additional, non-refundable fee for a pet living on the premises.
        `
    },
    additionPetFeeDescription: {
        title: 'Additional Pet Fee Descript Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
           How the amount entered into the Additional Pet Fee field is charged for a pet(s) living on the premises.
        `,
        generalHelp: [
            '1st Pet: The non-refundable Additional Pet Fee amount applies to just the 1st Pet living on the premises.',
            'Each: The non-refundable Additional Pet Fee amount applies to each pet living on the premises.',
            'One Time: The non-refundable Additional Pet Fee amount is a one-time fee paid by the tenants regardless of how many pets live on the premises (note that a Max Number of Pets may still be entered for a property).',
            'Per Additional Pet: The non-refundable Additional Pet Fee amount applies for each additional pet after the 1st pet.',
            'Per Pet: The non-refundable Additional Pet Fee amount applies per pet living on the premises.',
            'See Remarks: See Remarks for specific details on when the Additional Pet Fee applies.'
        ]
    },
    minimumLeaseMonths: {
        title: 'Min Lease Months Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
           The minimum amount of months the lease can be.
        `
    },
    maximumLeaseMonths: {
        title: 'Max Lease Months Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
           The maximum amount of months the lease can be.
        `
    },
    availableDate: {
        title: 'Availability Date Help',
        ruleHelp: ['Availability Date is required.'],
        generalHelpDesc: `
           The date the property will be available for possession/occupation. 
            <a href="https://ddwiki.reso.org/display/DDW17/AvailabilityDate+Field" target="_blank" rel="noopener noreferrer">RESO AvailabilityDate</a>.
        `
    },
    certifiedFunds: {
        title: 'Certified Funds YN Help',
        ruleHelp: ['Certified Funds YN is required.'],
        generalHelpDesc: `
           Funds containing a certification that the drawer of the funds has sufficient funds in the bank to cover payment.
        `
    },
    leaseGuarantorYN: {
        title: 'Lease Guarantor YN Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
          A person who will co-sign an apartment lease alongside a tenant, guaranteeing to pay the rent if the tenant fails to do so.
        `
    },
    leaseTerm: {
        title: 'Lease Term Help',
        ruleHelp: ['Lease Term is required.'],
        generalHelpDesc: `
           A pick list of lengths that represent the length of the lease.
            <a href="https://ddwiki.reso.org/display/DDW17/LeaseTerm+Field" target="_blank" rel="noopener noreferrer">RESO LeaseTerm</a>.
        `,
        generalHelp: [
            'Weekly: The length of the lease is weekly.',
            'Month to Month: The length of the lease is month to month.',
            '12 Months: The length of the lease is 12 months.',
            'Negotiable: The length of the lease is negotiable.',
            'Renewal Option: The lease has a renewal option.'
        ]
    },
    applicationPolicy: {
        title: 'Application Policy Help',
        ruleHelp: ['Application Policy is required.'],
        generalHelpDesc: `
           Best Qualified: the most qualified application will be selected as the tenant, regardless of the order the applications were received.
           <br /><br />
           First Qualified: the first application that is processed and accepted will be the new tenant.
        `
    },
    applicationRequired: {
        title: 'Application Required Help',
        ruleHelp: ['Application Required is required.'],
        generalHelpDesc: `
           The type of documentation required when submitting a rental application.
        `
    },
    oneTimeExpenses: {
        title: 'One Time Expenses Help',
        ruleHelp: ['One Time Expenses is required.'],
        generalHelpDesc: `
            One time expenses as part of the application and/or move in process.
        `
    },
    recurringExpenses: {
        title: 'Recurring Expenses Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
            Expected recurring expenses for tenant.
        `
    },
    sellerContributionsYN: {
        title: 'Owner Contributions YN Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
            Sellers/lessors can advertise if they’re willing to make monetary concessions to a potential buyer/tenant.
        `,
        generalHelp: [
            'Y/N field',
            'Optional field',
            'Will syndicate to public websites',
            'More details about the Seller/Owner Contribution offered can be added to the Public and Private Remarks fields if they do not contain any reference to buyer agent compensation.',
            'Any Seller/Owner Contribution may not be limited to or conditioned on the retention of or payment to a cooperating broker, buyer broker, or other buyer representative.'
        ]
    },
    intermediaryYN: {
        title: 'Intermediary YN Help',
        ruleHelp: ['Intermediary YN is required.'],
        generalHelpDesc: `
            An intermediary is a broker who negotiates the transaction between the parties when the broker or a sales agent sponsored by the broker has obtained consent from the parties to represent both the buyer and the seller. The broker intermediary may, with the written consent of the parties, appoint separate individual license holder associated with the broker to work with and advise the party to whom they have been appointed.
        `
    },
    rentSpreeOnlineApplicationYN: {
        title: 'Rent Spree YN Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
            RentSpree Online Screening
        `,
        generalHelp: [
            "Select 'Yes' to use RentSpree’s online rental application and instant rental screening.",
            'You will receive a link via email and text message to share with applicants.',
            'Once applicants apply, you will receive a completed rental application, credit report, background check, and eviction-related proceedings. See restrictions.',
            'Applicants pay $39.99 to apply. RentSpree is free for you to use.',
            'Visit https://www.rentspree.com/unlockmls for more information.'
        ]
    },
    applicationDeliverAddress: {
        title: 'App Delivery To Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
           The email address to send the rental application, as needed.
        `
    },
    websiteAppLinkPublicView: {
        title: 'Online App Instructions Public Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
           The URL for potential tenants to submit their application.
        `
    },
    websiteAppLinkAgentView: {
        title: 'Online App Instructions Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
           The URL for the agent to share with potential tenants to submit their application.
        `
    },
    occupantType: {
        title: 'Occupant Type Help',
        ruleHelp: ['Occupant Type is required.'],
        generalHelpDesc: `
           A field that describes the type of occupant, i.e. Owner, Tenant, Vacant. 
            <a href="https://ddwiki.reso.org/display/DDW17/OccupantType+Field" target="_blank" rel="noopener noreferrer">RESO OccupantType</a>.
        `,
        generalHelp: ['Owner: The occupant is the owner.', 'Tenant: The occupant is a tenant.', 'Vacant: The property is vacant.']
    },
    ownerName: {
        title: 'Owner Name Help',
        ruleHelp: ['Owner Name is required.'],
        generalHelpDesc: `
           Name of the owner of the property being sold. Name may be withheld, with written permission from the owner on file at the agent's office.
            <a href="https://ddwiki.reso.org/display/DDW17/OwnerName+Field" target="_blank" rel="noopener noreferrer">RESO OwnerName</a>.
        `
    },
    accessCode: {
        title: 'Access Code Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
           If the property is located behind an unmanned security gate such as in a Gated Community, what is the code to gain access through the secured gate.
            <a href="https://ddwiki.reso.org/display/DDW17/AccessCode+Field" target="_blank" rel="noopener noreferrer">RESO AccessCode</a>.
        `
    },
    lockboxType: {
        title: 'Lock Box Type Help',
        ruleHelp: ['Lock Box Type is required.'],
        generalHelpDesc: `
           A field describing the type of lock box. 
            <a href="https://ddwiki.reso.org/display/DDW17/LockBoxType+Field" target="_blank" rel="noopener noreferrer">RESO LockBoxType</a>.
        `,
        generalHelp: [
            'Both: A listing has both a combo lockbox and an electronic lockbox at the property.',
            'Combo Lockbox: The lockbox on the property is opened via combination. See remarks or contact the agent/office for the combination.',
            'Electronic Lockbox: A lockbox that requires an electronic key (such as a Supra eKEY) to unlock.',
            'None: There is no lockbox on the property.'
        ]
    },
    lockboxLocation: {
        title: 'Lock Box Description Help',
        ruleHelp: ['Lock Box Description is required.'],
        generalHelpDesc: `
           A field describing the location of the lock box.
        `
    },
    lockboxSerialNumber: {
        title: 'Lock Box Serial Number Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
           The serial number of the lockbox placed on the property. Required to enter if Both, Combo, or Electronic Lockbox is selected on Lockbox Type. 
            <a href="https://ddwiki.reso.org/display/DDW17/LockBoxSerialNumber+Field" target="_blank" rel="noopener noreferrer">RESO LockBoxSerialNumber</a>.
        `
    },
    managementCompany: {
        title: 'Management Company Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
           Management Company
        `
    },
    managementCompanyPhone: {
        title: 'Management Co Phone Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
           Management Co Phone
        `
    },
    managementCompanyRep: {
        title: 'Management Co Rep Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
           Management Co Rep
        `
    },
    showingContactName: {
        title: 'Showing Contact Name Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
           The name of the contact for the showing of the listed property.
            <a href="https://ddwiki.reso.org/display/DDW17/ShowingContactName+Field" target="_blank" rel="noopener noreferrer">RESo ShowingContactName</a>.
        `
    },
    showingContactPhone: {
        title: 'Showing Contact Phone Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
           A telephone number that should be called to arrange showing the property.
            <a href="https://ddwiki.reso.org/display/DDW17/ShowingContactPhone+Field" target="_blank" rel="noopener noreferrer">RESO ShowingContactPhone</a>.
        `
    },
    showingServicePhone: {
        title: 'Showing Call Service Phone Help',
        ruleHelp: ['No rule help message defined.'],
        generalHelpDesc: `
           If using a Showing Service (ex. ShowingTime) that uses a call center to arrange the showing, input the call center/service's phone number here. Must also select "Showing Service" from Showing Requirements.
        `
    },
    showingRequirements: {
        title: 'Showing Requirements Help',
        ruleHelp: ['Showing Requirements is required.'],
        generalHelpDesc: `
           A pick list of types of notice required to see the home. i.e. Appointment Required, Courtesy Call Only, Go Direct, etc.
            <a href="https://ddwiki.reso.org/display/DDW17/ShowingRequirements+Field" target="_blank" rel="noopener noreferrer">RESO ShowingRequirements</a>.
        `,
        generalHelp: [
            '24 Hour Notice: A 24 hour notice is required to show the property.',
            'Agent or Owner Present: Either the Listing Agent or Owner must be present at all showings.',
            'Appointment Only: Showing of the property is by appointment only.',
            'Call First - Go: Showing instruction where the buyer must call to let the seller know they are showing the property, but does not require approval or a response.',
            'Call Listing Agent: Call the listing agent to arrange a showing of the property.',
            'Call Listing Office: Call the listing office to arrange a showing of the property.',
            'Call Manager: Call the property manager to arrange a showing of the property.',
            'Call Owner: Call the property owner to arrange a showing of the property.',
            'Call Tenant: Call the tenant/occupant directly to arrange a showing of the property.',
            'Day Sleeper: The property has a tenant/occupant who sleeps during the day.',
            'Do Not Disturb Tenant, Mgt, etc.: Describes hours of the day that the tenant, management, or another party does not want communication.',
            'Email Listing Agent: Email the listing agent for more information about showing the property.',
            "Go: Showing appointment type that gives the Buyer's Agent permission to go directly to the property. No need to call prior.",
            "Key in Office: The key to access the property for showing must be retrieved from the listing or manager's office.",
            'Key with Gate Guard: The key to the dwelling is located with the gate guard.',
            'Key with Listing Office: In order to gain access to the property, the key will be accessible with an office that has listed the property.',
            'Key with Listing Agent: The key to the dwelling is located with the listing agent.',
            'Key with Management Company: The liaison of the property will provide the key for access.',
            'Key with Occupant: The person(s) that are in the property/dwelling will provide a key for access.',
            'Key with Owner: The owner of the property/dwelling will provide a key for access.',
            'Lockbox: The property has an electronic lockbox for showing access.',
            'Pet(s) on Premises: There are currently pets at the property.',
            'Restricted Hours: The times when the property may be shown are restricted.',
            'Security System: The property has a security system that is a consideration when showing.',
            'Showing Service: A service used by a listing broker to provide showing services of listed properties. Ex. ShowingTime',
            'Sign On Property: There is a visible sign on the property.',
            'Text Listing Agent: Text message the listing agent to arrange a showing of the property.',
            'See Showing Instructions: Select this option to clarify that an agent needs to review your details located in the Showing Instructions open-text field.'
        ]
    },
    showingContactType: {
        title: 'Showing Contact Type Help',
        ruleHelp: ['Showing Contact Type is required.'],
        generalHelpDesc: `
          The type of contact for the showing. i.e. Agent, Broker, Seller. 
            <a href="https://ddwiki.reso.org/display/DDW17/ShowingContactType+Field" target="_blank" rel="noopener noreferrer">RESO ShowingContactType</a>.
        `,
        generalHelp: [
            'Agent: The showing contact is a licensed agent.',
            'Occupant: The showing contact is the occupant.',
            'Owner: The showing contact is the owner.',
            'Property Manager: The showing contact is the property manager.'
        ]
    },
    showingInstructions: {
        title: 'Showing Instructions Help',
        ruleHelp: ['Showing Instructions is required.'],
        generalHelpDesc: `
          Definition and Rules for Showing Instructions 
        `,
        generalHelp: [
            'Agent: The showing contact is a licensed agent.',
            'Occupant: The showing contact is the occupant.',
            'Owner: The showing contact is the owner.',
            'Property Manager: The showing contact is the property manager.'
        ]
    }
};
